/**
 * Hebrew — the source-of-truth locale. Worki is Hebrew-native, RTL-native;
 * every other locale is a translation of this file.
 * Interpolation uses {{name}} placeholders (i18next syntax).
 */
import { completionHe } from './completion.js';
import { customerPaymentsTranslations } from './customerPayments.js';
export const he = {
  customerPayments: customerPaymentsTranslations.he,
  completion: completionHe,
  googleCalendar: {
    failedCount: 'שגיאות סנכרון',
    confirmAccount: 'אישור חשבון Google',
    confirmAccountHint: 'בדקו שזה חשבון Google האישי שברצונכם לחבר.',
    confirmConnection: 'אישור וחיבור היומן',
    flowMismatch: 'החיבור התחיל בחלון או בחשבון אחר. יש להתחיל מחדש מכאן.',
    title: 'יומן Google האישי שלך',
    description: 'סנכרון התזכורות שלך והפגישות שקבעת ב־Worki ליומן Google האישי. שינויים ביומן Google אינם מיובאים ל־Worki.',
    connect: 'חיבור Google Calendar',
    disconnect: 'ניתוק היומן',
    connected: 'היומן מחובר',
    disconnected: 'היומן אינו מחובר',
    unavailable: 'חיבור Google Calendar עדיין לא מוגדר בשרת הזה.',
    pending: 'ממתין לסנכרון',
    synced: 'סונכרן',
    error: 'הסנכרון לא הצליח',
    retry: 'ניסיון סנכרון נוסף',
    oauthFailed: 'חיבור היומן לא הצליח. נסו שוב.',
    oauthCancelled: 'חיבור היומן בוטל.',
    reconnectRequired: 'יש לחבר את היומן מחדש לחידוש ההרשאה.',
    disconnectHint: 'הסנכרון יופסק. אירועים שכבר נוצרו ביומן Google יישארו בו.',
    lastSynced: 'סנכרון אחרון',
    durationHint: 'תזכורות מוצגות ביומן Google למשך 15 דקות ופגישות למשך 30 דקות.',
    revokeFailed: 'הסנכרון ב־Worki הופסק. ביטול ההרשאה ב־Google לא הצליח; אפשר להסיר את הגישה של Worki בהגדרות חשבון Google.',
    connectionCompleted: 'יומן Google חובר. חזרו ל־Worki לצפייה במצב הסנכרון.',
    returnToApp: 'חזרה ל־Worki',
  },
  calendar: {
    emptyDay: 'אין פגישות או תזכורות ביום הזה',
    eventsCount: '{{count}} אירועים',
    eventsCount_one: 'אירוע אחד',
    eventsCount_two: '{{count}} אירועים',
    eventsCount_other: '{{count}} אירועים',
    selectedDay: 'אירועי היום הנבחר',
    reminderKind: 'תזכורת',
    meetingKind: 'פגישה',
    title: 'יומן Worki', day: 'יום', week: 'שבוע', month: 'חודש', today: 'היום',
    previous: 'לתקופה הקודמת', next: 'לתקופה הבאה', date: 'תאריך', view: 'תצוגה',
    empty: 'אין פגישות או תזכורות בתקופה הזו', loadMore: 'הצגת אירועים נוספים',
    openReminder: 'פתיחת תזכורת', openMeeting: 'פתיחת פגישה',
  },
  digitalDocument: {"checked": "כן", "unchecked": "לא", "toFill": "למילוי על ידי הלקוח", "enterValue": "הזינו ערך", "chooseOption": "בחרו אפשרות", "fillHint": "מלאו את הפרטים לפני החתימה. שדות המסומנים בכוכבית הם שדות חובה.", "clearSignature": "ניקוי החתימה", "signHere": "חתימה"},
  common: {
    print: 'הדפסה',
    selectAllMatching: 'בחירת כל העמודים ({{count}} פריטים)',
    bulkSomeFailed: '{{count}} פריטים לא עודכנו. הם נשארו מסומנים כדי שתוכלו לבדוק ולנסות שוב.',
    bulkShareLimit: 'אפשר לשתף עד {{count}} מסמכים בכל פעם. צמצמו את הבחירה לפני השיתוף.',
    bulkSelectionLimit: 'אפשר לבחור עד {{count}} מסמכים בכל פעם. צמצמו את המסננים ונסו שוב.',
    pickContact: 'בחירה מאנשי הקשר',
    contactUnavailable: 'לא ניתן לפתוח את אנשי הקשר במכשיר הזה.',
    contactPermissionDenied: 'אפשרו גישה לאנשי הקשר כדי לבחור לקוח.',
    appName: 'Worki',
    save: 'שמירה',
    // For the toast that follows a save. `save` is the button label — showing it
    // again as the confirmation reads like an instruction, not a result.
    saved: 'נשמר בהצלחה',
    deleted: 'נמחק בהצלחה',
    // Filter dropdowns sit in a toolbar with no room for a visible label, so the
    // unselected option carries it. Two neighbouring selects both reading 'הכל'
    // said nothing about what they filtered.
    allOf: '{{label}}: הכל',
    cancel: 'ביטול',
    close: 'סגירה',
    edit: 'עריכה',
    delete: 'מחיקה',
    view: 'צפייה',
    create: 'יצירה',
    add: 'הוספה',
    remove: 'הסרה',
    search: 'חיפוש',
    share: 'שיתוף',
    clear: 'ניקוי',
    back: 'חזרה',
    next: 'הבא',
    previous: 'הקודם',
    moveUp: 'הזזה למעלה',
    moveDown: 'הזזה למטה',
    no: 'לא',
    loading: 'טוען…',
    empty: 'אין נתונים להצגה',
    error: 'אירעה שגיאה',
    // Every server action that can fail offers this next to its error.
    retry: 'ניסיון חוזר',
    /* Round 3 — what a screen reader says for the small 'i' beside a control. */
    explain: 'הסבר',
    // Hebrew inflects for one, so i18next picks the form from `count`.
    selected_one: 'נבחרה שורה אחת',
    selected: '{{count}} נבחרו',
    selectAll: 'בחירת הכל',
    clearSelection: 'ניקוי הבחירה',
    // The control that turns selection on, for anyone who does not know that
    // holding a row for half a second does the same thing.
    selectMode: 'מצב בחירה',
    selectRow: 'בחירת שורה',
    actions: 'פעולות',
    all: 'הכל',
    none: 'ללא',
    optional: 'רשות',
    copy: 'העתקה',
    copied: 'הועתק',
    download: 'הורדה',
    document: 'מסמך',
    documentFailed: 'לא ניתן להציג את המסמך כאן',
    openInNewTab: 'פתיחה בכרטיסייה חדשה',
    openFullScreen: 'מסך מלא',
    zoomIn: 'הגדלה',
    zoomOut: 'הקטנה',
    send: 'שליחה',
    viewAll: 'הצג הכל',
    of: 'מתוך',
    results: 'תוצאות',
    page: 'עמוד',
    logout: 'התנתקות',
    language: 'שפה',
  },
  // What the new shell calls the screens it does not take from the reference
  // build. The labels the old menu had for the reference's own screens are gone
  // with it — those live under `shell` now, and one screen with two names is how
  // a menu entry and its page end up disagreeing.
  nav: {
    dashboard: 'לוח בקרה',
    activity: 'יומן פעילות',
    notifications: 'התראות',
    reminders: 'תזכורות',
    menu: 'תפריט',
    billing: 'מנוי ותשלומים',
    // מוצג רק לצוות Worki. לכל השאר הוא פשוט לא קיים בתפריט.
    platform: 'ניהול פלטפורמה',
  },
  auth: {
    loginTitle: 'כניסה ל-Worki',
    loginSubtitle: 'נהל הצעות מחיר, לידים וחשבוניות במקום אחד',
    signupTitle: 'פתיחת חשבון',
    signupSubtitle: 'התחילו לנהל את העסק שלכם בדקות',
    email: 'אימייל',
    name: 'שם מלא',
    businessName: 'שם העסק',
    login: 'כניסה',
    signup: 'הרשמה',
    noAccount: 'אין לכם חשבון?',
    haveAccount: 'כבר יש לכם חשבון?',
    otp: 'קוד כניסה',
    otpInvalid: 'קוד הכניסה שגוי או שפג תוקפו',
    deleteConfirmMismatch: 'זו לא כתובת האימייל של החשבון הזה',
    sendCode: 'שלחו לי קוד כניסה',
    codeSent: 'שלחנו קוד כניסה אל {{email}}',
    codeExpiry: 'הקוד תקף ל-10 דקות ולשימוש חד-פעמי',
    changeEmail: 'שימוש באימייל אחר',
    signupCodeSent: 'שלחנו קוד אימות אל {{email}}. הזינו אותו כדי להשלים את פתיחת החשבון.',
    confirmSignup: 'אישור ופתיחת חשבון',
    editDetails: 'שינוי הפרטים',
    phone: 'טלפון נייד',
    trade: 'תחום עיסוק',
    tradePick: 'בחרו תחום',
    tradeSearch: 'חיפוש תחום',
    tradeNoMatch: 'אין תחום בשם הזה',
    taxId: 'ח.פ / ע.מ',
    taxIdHint: 'מספר עוסק מורשה או ח.פ, 8 עד 9 ספרות',
    city: 'יישוב',
    cityHint: 'לא חובה',
    /* LEGAL-001 — ארבעה חלקים ולא משפט אחד, כדי ששני השמות יהיו קישורים.
       „ו” נצמדת למילה שאחריה בעברית, ולכן הרווח נמצא לפניה ולא אחריה. */
    termsPrefix: 'קראתי ואני מאשר את ',
    termsLink: 'תנאי השימוש',
    termsAnd: ' ו',
    privacyLink: 'מדיניות הפרטיות',
    google: 'המשך עם Google',
    orEmail: 'או באמצעות אימייל',
    googleTitle: 'עוד רגע וסיימנו',
    googleSubtitle: 'נכנסתם עם {{email}}. נשארו רק פרטי העסק.',
    // 1.34 — the sign-up went through and the account waits for Worki to open it.
    // Above the card that carries `errors.accountPending`.
    signupPendingTitle: 'ההרשמה הושלמה',
    signupPendingSubtitle: 'נרשמתם עם {{email}}',
    pitchTitle: 'כל העסק שלכם במסך אחד',
    pitchBody: 'Worki אוסף את הפניות, כותב את הצעות המחיר ועוקב אחרי הלקוחות — בלי גיליונות ובלי לרדוף אחרי מספרים.',
    pitchLeads: 'פניות שלא הולכות לאיבוד',
    pitchLeadsBody: 'שיחות, טפסים והודעות נכנסים לרשימה אחת עם סטטוס ותזכורת.',
    pitchQuotes: 'הצעת מחיר בדקה',
    pitchQuotesBody: 'בונים, שולחים בוואטסאפ או במייל, ורואים מתי הלקוח פתח ואישר.',
    pitchInvoices: 'חשבוניות בלי עבודה',
    pitchInvoicesBody: 'החשבוניות שמגיעות לתיבה נקראות לבד ונכנסות לדוחות.',
    pitchFooter: 'Worki — ניהול העסק הקטן, בעברית',
  },
  // מסך פנימי של Worki (מודול 13). הקהל שלו הוא עובדי Worki, לא בעלי עסקים,
  // ולכן הניסוח כאן מדבר על "עסקים" ולא על "לקוחות" — לקוח, במוצר הזה, הוא
  // הלקוח של בעל העסק.
  platform: {
    searchPlaceholder: 'חיפוש לפי שם, אימייל או כתובת מיני-סייט',
    allStatuses: 'כל הסטטוסים',
    businesses: 'עסקים',
    active: 'משלמים',
    trialing: 'בתקופת ניסיון',
    pastDue: 'בפיגור תשלום',
    signupsThisMonth: 'נרשמו החודש',
    activeThisWeek: 'פעילים השבוע',
    business: 'עסק',
    plan: 'מסלול',
    status: 'סטטוס',
    users: 'משתמשים',
    customers: 'לקוחות',
    quotes: 'הצעות',
    lastActivity: 'פעילות אחרונה',
    joined: 'הצטרפו',
    never: 'מעולם לא',
    empty: 'אין עסקים שמתאימים לסינון',
    detailTitle: 'כרטיס עסק',
    subscriptionHistory: 'היסטוריית המנוי',
    noSubscriptionHistory: 'לא נרשמה עדיין פעילות חיוב בחשבון זה.',
    billingEvent: {
      checkout_started: 'התחלת תשלום',
      cancelled: 'המנוי בוטל',
      subscription_activated: 'המנוי הופעל',
      subscription_cancelled: 'המנוי בוטל אצל הסולק',
      payment_succeeded: 'תשלום התקבל',
      payment_failed: 'תשלום נכשל',
      // הסולק שלח הודעה שאין לה מקבילה במנוי: היא נשמרה, ושום דבר לא השתנה.
      ignored: 'הודעה מהסולק, ללא שינוי במנוי',
    },
    contact: 'פרטי קשר',
    usage: 'שימוש',
    inquiries: 'פניות',
    invoices: 'חשבוניות',
    galleries: 'גלריות',
    mailAccounts: 'תיבות דואר מחוברות',
    quotesThisMonth: 'הצעות החודש',
    voiceActionsThisMonth: 'הצעות בהכתבה ל-AI החודש',
    trialEnds: 'הניסיון מסתיים',
    periodEnds: 'החיוב הבא',
    provider: 'ספק סליקה',
    slug: 'מיני-סייט',
    // המשפט הזה הוא הבטחה, לא הערה: הפעולה היחידה שמשנה נתונים כאן היא ניהול
    // המשתמשים, ואין במסך נתונים של לקוחות הלקוח.
    readOnly: 'המסך הזה קורא בלבד, מלבד פתיחת הגישה לחשבון או סגירתה. הוא לא מציג לקוחות, הצעות או תוכן של העסק — רק מספרים.',
  },
  /*
   * The subscription. The account screen says which plan a business is on and
   * how much of it is used; the billing screen is where another one is chosen
   * and paid for.
   */
  billing: {
    title: 'מנוי ותשלומים',
    subtitle: 'המסלולים והמעבר ביניהם',
    currentPlan: 'המסלול הנוכחי',
    changePlan: 'החלפת מסלול',
    perMonth: 'לחודש',
    choose: 'בחירת המסלול',
    currentBadge: 'המסלול שלכם',
    status: {
      trialing: 'תקופת ניסיון',
      active: 'פעיל',
      past_due: 'ממתין לתשלום',
      cancelled: 'בוטל',
      expired: 'פג תוקף',
    },
    trialEndsAt: 'תקופת הניסיון מסתיימת ב-{{date}}',
    renewsAt: 'המנוי יתחדש ב-{{date}}',
    cancelledAt: 'המנוי בוטל ופעיל עד {{date}}',
    pastDueNotice: 'החיוב האחרון לא עבר. עדכנו את אמצעי התשלום — עד אז החשבון עובר לצפייה בלבד.',
    inactiveNotice: 'המנוי אינו פעיל, ולכן החשבון במצב צפייה בלבד. חדשו את המנוי כדי להמשיך לערוך.',
    card: 'כרטיס שמסתיים ב-{{last4}}',
    usage: {
      connectedMailAccounts: 'תיבות דוא"ל מחוברות',
      galleries: 'גלריות',
      quotesThisMonth: 'הצעות מחיר החודש',
      voiceActionsThisMonth: 'הצעות בהכתבה ל-AI החודש',
    },
    // The same three caps as `usage`, named as a cap rather than as a counter:
    // the account screen says how many quotes went out this month, the plan
    // picker says how many a month the plan allows.
    limitLabel: {
      connectedMailAccounts: 'תיבות דוא"ל מחוברות',
      galleries: 'גלריות',
      quotesPerMonth: 'הצעות מחיר בחודש',
      voiceActionsPerMonth: 'הצעות בהכתבה ל-AI בחודש',
    },
    unlimited: 'ללא הגבלה',
    // A cap of zero: the plan does not have it at all (voice on starter).
    notIncluded: 'לא כלול',
    usageOf: '{{used}} מתוך {{limit}}',
    usageLeft: 'נותרו {{left}}',
    cancel: 'ביטול המנוי',
    cancelConfirm: 'לבטל את המנוי? הגישה נשמרת עד סוף התקופה ששולמה, ואחריה החשבון עובר לצפייה בלבד.',
    cancelDone: 'המנוי בוטל',
    checkout: 'מעבר לתשלום',
    checkoutFailed: 'לא הצלחנו לפתוח את דף התשלום. נסו שוב.',
    paymentSuccess: 'התשלום התקבל והמסלול עודכן',
    paymentCancelled: 'התשלום בוטל ולא בוצע חיוב',
    plans: {
      starter: 'בסיסי',
      business: 'עסקי',
      pro: 'מקצועי',
    },
    planTagline: {
      starter: 'לעצמאי שמנהל לבד את ההצעות והלקוחות',
      business: 'לעסק בקצב הצעות גבוה: מכתיבים ל-AI מה להציע, והוא מכין הצעה כתובה שנשלחת ללקוח רק אחרי שאישרתם',
      pro: 'לעסק שמכין את רוב ההצעות בהכתבה ל-AI, עם הכי הרבה הכתבות בחודש',
    },
  },
  dashboard: {
    finances: {
      incomeExpenses: 'הכנסות והוצאות משוערות',
      year: 'שנה',
      chartHeight: 'גובה הגרף',
      annualTotals: 'סיכום שנתי',
      expectedRevenue: 'הכנסה צפויה מהצעות שאושרו', thisMonth: 'החודש',
      approvedCount: '{{count}} הצעות שאושרו', sixMonths: 'ששת החודשים האחרונים',
      archivedInvoices: 'חשבוניות החודש', archiveHint: 'סכומי חשבוניות שזוהו בארכיון החודש, ב־{{currency}}',
      income: 'הכנסות', expenses: 'הוצאות', unavailable: 'לא ניתן לטעון את הסיכום הכספי',
    },
    /* The greeting changes with the hour, so the screen does not say the same
       sentence at six in the morning and at eleven at night. */
    greeting: {
      morning: 'בוקר טוב, {{name}}',
      noon: 'צהריים טובים, {{name}}',
      evening: 'ערב טוב, {{name}}',
      night: 'לילה טוב, {{name}}',
    },
    range: {
      today: 'היום',
      week: 'השבוע',
      month: 'החודש',
      all: 'מאז ומתמיד',
    },
    kpi: {
      quotesSent: 'הצעות שנשלחו',
      quotesApproved: 'הצעות שאושרו',
      incomingCalls: 'שיחות נכנסות',
      // תוויות משנה בתוך כרטיס נתונים, שכותרתו כבר אומרת מה נמדד.
      sentShort: 'נשלחו',
      pendingShort: '{{count}} ממתינות',
      rejectedShort: '{{count}} נדחו',
      missedShort: '{{count}} לא נענו',
      callsTotal: 'סה״כ שיחות',
    },
    conversion: '{{rate}}% המרה',
    meetings: 'פגישות שנקבעו',
    meetingsEmpty: 'אין פגישות להיום',
    // השורה שמתחת למספר. לחודש ראשון אין מול מה להשוות, ולכן הוא אומר כמה
    // ולא ממציא אחוז.
    vsLastMonth: '{{percent}}% מהחודש שעבר',
    meetingsThisMonth: '{{count}} החודש',
    overdueCount: '{{count}} באיחור',
    allReminders: 'כל התזכורות',
    moreReminders: 'עוד {{count}} תזכורות',
    stats: 'סטטיסטיקות',
    openReminders: 'תזכורות ופגישות',
    noReminders: 'אין תזכורות פתוחות',
    quickActions: 'פעולות מהירות',
    newQuote: 'הצעת מחיר חדשה',
    newLead: 'ליד חדש',
    newReminder: 'תזכורת חדשה',
    newReminderMeeting: 'תזכורת או פגישה חדשה',
  },
  calls: {
    title: 'שיחות', subtitle: 'היסטוריית שיחות נכנסות ויוצאות', caller: 'מתקשר', unknown: 'מתקשר לא מזוהה',
    startedAt: 'תאריך ושעה', duration: 'משך', status: 'סטטוס', direction: 'כיוון', inbound: 'נכנסת',
    outbound: 'יוצאת', redial: 'חיוג חוזר', notes: 'הערות לשיחה',
    searchPlaceholder: 'חיפוש לפי מתקשר או מספר…',
    // TEL-005 — the call knows which customer it belongs to; before this the
    // only way from a call to that customer's card was through the customer list.
    customer: 'לקוח', openCustomer: 'כרטיס הלקוח', unmatched: 'השיחה לא שויכה ללקוח',
    deleteConfirm: 'למחוק את רשומת השיחה? הפעולה אינה הפיכה.',
    emptyTitle: 'אין שיחות עדיין', emptyBody: 'שיחות למספר הווירטואלי שלכם יופיעו כאן אוטומטית.',
    // Shown instead of the line above while no number is set: without one the
    // provider has nothing to route and no call can ever arrive.
    emptyNoNumber: 'עדיין לא הוגדר מספר וירטואלי. הגדירו אותו בפרופיל שלי כדי שהשיחות יתועדו כאן.',
  },
  miniSite: {
    subtitle: 'חלון הראווה הציבורי וערוץ הפניות של העסק', viewSite: 'צפייה באתר',
    slug: 'כתובת ציבורית', cover: 'תמונת שער', about: 'אודות העסק',
    // Shown under the address field while it is still empty: without a saved
    // slug the public site has no address at all and cannot be opened.
    slugEmpty: 'האתר הציבורי לא זמין עד שתבחרו כתובת ותשמרו. לדוגמה: {{example}}',
    // Nitzan's one-page gallery layout.
    areas: { north: 'צפון', haifa: 'חיפה והקריות', sharon: 'השרון', center: 'מרכז', jerusalem: 'ירושלים', shfela: 'שפלה', south: 'דרום', eilat: 'אילת' },
    serviceArea: 'אזור פעילות', specialties: 'סוגי התמחות',
    yearsActive_one: 'שנת פעילות אחת', yearsActive_two: 'שנתיים של פעילות', yearsActive_other: '{{count}} שנות פעילות',
    projectsDone_one: 'פרויקט אחד', projectsDone_two: '2 פרויקטים', projectsDone_other: '{{count}} פרויקטים',
    projects: 'פרויקטים', newRating: 'יצירת דירוג חדש',
    ratedByOf_one: 'מתוך מדרג אחד', ratedByOf_two: 'מתוך 2 מדרגים', ratedByOf_other: 'מתוך {{count}} מדרגים',
    showAllAlbums: 'הצג הכל ({{count}})', city: 'יישוב', whatsapp: 'וואטסאפ', like: 'אהבתי', call: 'חיוג', shareGallery: 'שיתוף גלריה',
    slogan: 'סלוגן', foundedYear: 'שנת פתיחה', projectsCount: 'מספר פרויקטים',
    coverMenu: 'אפשרויות תמונה', removeCover: 'הסרת תמונת נושא', removeLogo: 'הסרת תמונת פרופיל',
    removeCoverConfirm: 'להסיר את תמונת הנושא?', removeLogoConfirm: 'להסיר את תמונת הפרופיל?',
    editAbout: 'עריכת אודות',
    // The four panels of the screen, in the order a visitor to the public site
    // meets them: what the business made, what it is selling now, what its
    // customers said, and who it is.
    tabs: { gallery: 'גלריה', promotions: 'מבצעים', reviews: 'חוות דעת', about: 'אודות' },
    share: 'שיתוף', linkCopied: 'הקישור לאתר הועתק',
    // The share sheet needs an address, and there is none until a slug is saved.
    slugRequired: 'בחרו כתובת ציבורית ושמרו לפני השיתוף',
    changeCover: 'החלפת שער', changeLogo: 'החלפת לוגו', editName: 'עריכת שם העסק',
    galleries: 'גלריות', newGallery: 'גלריה חדשה', createGallery: 'הוספת גלריה',
    editGallery: 'עריכת גלריה', noGalleries: 'עדיין אין גלריות',
    noGalleriesHint: 'כל גלריה היא עבודה אחת שלכם: תמונות, תיאור ומחיר. זה מה שלקוח רואה קודם.',
    noSearchResults: 'אין גלריה שמתאימה לחיפוש',
    searchGalleries: 'חיפוש גלריה',
    orderGalleries: 'סדר הגלריות',
    orderHint: 'גררו גלריה למעלה או למטה — זה הסדר שהלקוח יראה באתר',
    orderSaved: 'הסדר נשמר',
    viewMode: 'תצוגה', viewGrid: 'רשת', viewList: 'רשימה',
    images: 'תמונות', views: 'צפיות', addImage: 'הוספת תמונה', uploadImages: 'העלאת תמונות',
    setCover: 'הגדרה כתמונת נושא', galleryName: 'שם הגלריה', openImage: 'פתיחת התמונה',
    imagesCount: '{{count}} תמונות', viewsCount: '{{count}} צפיות', unitsLeft: 'נותרו {{count}} יחידות',
    noImages: 'אין תמונות בגלריה', noDescription: 'לא נכתב תיאור',
    description: 'תיאור', price: 'מחיר', quantity: 'כמות זמינה', priceFrom: 'הצגת „החל מ-”',
    published: 'מפורסם באתר', hidden: 'מוסתר', onSale: 'מוצג כמבצע',
    // Corner badges on a gallery card. Short because they sit over the photo.
    badgeNew: 'חדש', badgeSale: 'מבצע',
    deleteGallery: 'למחוק לצמיתות את הגלריה ואת כל התמונות שבה?',
    // The bulk form of the line above, after a long press selected several.
    deleteGalleries: 'למחוק לצמיתות {{count}} גלריות ואת כל התמונות שבהן?',
    clearSelection: 'ביטול הבחירה',
    // The card menu. „שיתוף” here is the single gallery, not the whole site.
    albumMenu: 'תפריט הגלריה', deleteAlbum: 'מחיקת הגלריה', shareAlbum: 'שיתוף הגלריה',
    albumLinkCopied: 'הקישור לגלריה הועתק',
    markSale: 'סימון כמבצע', unmarkSale: 'הסרה מהמבצעים',
    // Opens the quote editor with the gallery name and price already filled in.
    attachToQuote: 'צירוף להצעת מחיר',
    album: 'אלבום',
    albumTabs: { description: 'תיאור הפרויקט', plans: 'תוכניות' },
    // Worki does not store drawings yet, so the tab says so instead of offering
    // an upload that has nowhere to go.
    noPlans: 'אין תוכניות מצורפות', plansHint: 'צירוף שרטוטים ותוכניות יגיע בהמשך.',
    reviews: 'חוות דעת', noReviews: 'עדיין אין חוות דעת',
    deleteImage: 'למחוק לצמיתות את התמונה מהגלריה?', deleteReview: 'למחוק לצמיתות את חוות הדעת?',
    newReview: 'חוות דעת חדשה', editReview: 'עריכת חוות דעת', addReview: 'הוספת חוות דעת',
    reviewBody: 'תוכן חוות הדעת', showPhone: 'הצגת הטלפון באתר הציבורי',
    // The three things a customer of a trade business actually judges. Each is
    // optional: a review that scores only one of them still counts.
    rating: { service: 'שירות', timeliness: 'עמידה בזמנים', value: 'תמורה למחיר' },
    ratingPreview: 'ממוצע חוות הדעת', ratingBreakdown: 'פירוט הדירוג', ratingOverall: 'ממוצע כללי',
    // The label a screen reader hears instead of five identical glyphs, and the
    // count beside the average — 4.3 from two reviews and 4.3 from forty are
    // different claims.
    ratingOf: '{{rating}} מתוך 5', ratedBy: '{{count}} דירוגים',
    // Offers. Separate from galleries because an offer is a price with a
    // deadline: the countdown is the point, so it is what the card leads with.
    offers: 'מבצעים', newOffer: 'מבצע חדש', createOffer: 'הוספת מבצע', editOffer: 'עריכת מבצע',
    noOffers: 'עדיין אין מבצעים',
    noOffersHint: 'מבצע הוא מחיר עם תאריך סיום. הוא יורד מהאתר מעצמו בתום התקופה.',
    offerName: 'שם המבצע', validDays: 'תוקף בימים',
    validDaysHint: 'המבצע יירד מהאתר מעצמו בתום התקופה',
    deleteOffer: 'למחוק לצמיתות את המבצע?',
    offerActive: 'פעיל', offerInactive: 'הסתיים',
    // A gallery marked as a sale shows up in the offers list too, labelled with
    // where it came from.
    fromAlbum: 'גלריה שסומנה כמבצע',
    daysLeft: 'נותרו {{count}} ימים', lastDay: 'היום האחרון', expired: 'פג תוקף',
    businessDescription: 'תיאור העסק', fields: 'תחומי עיסוק',
    newField: 'תחום עיסוק חדש', removeField: 'הסרת התחום',
    /*
     * What a visitor to the public site reads. Kept in the dictionary like
     * everything else: the page is the first thing a customer of the business
     * ever sees, and it was the one screen still writing its Hebrew inline.
     */
    public: {
      notFound: 'האתר המבוקש לא נמצא',
      contact: 'צרו קשר',
      contactTitle: 'נשמח לחזור אליכם',
      getDetails: 'קבלת פרטים',
      priceFrom: 'החל מ-',
      message: 'איך נוכל לעזור?',
      callNow: 'התקשרו עכשיו',
      whatsapp: 'WhatsApp',
      builtWith: 'נבנה עם Worki',
      galleries: 'גלריות',
      // The section heading and the nav link that jumps to it. Plural on the
      // heading even for one offer: the section is the section.
      offers: 'מבצעים',
      reviews: 'ביקורות',
      // The average and how many gave it. A number on its own says nothing —
      // 9.5 out of two reviews and 9.5 out of forty are different claims.
      rating: 'דירוג ממוצע',
      ratedBy: 'לפי {{count}} ביקורות',
      // Marketing consent has to be a real opt-in — a visitor who leaves it
      // unticked still gets an answer — and the notice under it is what
      // Privacy Protection Law s.11 requires before the details are typed.
      consentLabel: 'אני מאשר/ת לקבל הצעות ועדכונים מהעסק (לא חובה)',
      consentNote: 'נחזור אליכם בכל מקרה, וניתן לבטל את ההסכמה בכל עת.',
      privacyNotice: 'הפרטים שתמסרו — שם, טלפון, אימייל ותוכן הפנייה — אינם חובה, נשמרים אצל בעל העסק בלבד ומשמשים רק כדי לחזור אליכם.',
      submit: 'שליחת פנייה',
      sent: 'הפנייה נשלחה בהצלחה. נחזור אליכם בהקדם.',
      sendFailed: 'לא הצלחנו לשלוח את הפנייה. בדקו את הפרטים ונסו שוב.',
      gallery: 'גלריה',
      emptyGalleries: 'עדיין אין גלריות',
    },
  },
  inquiries: {
    one: 'פנייה',
    new: 'פנייה חדשה',
    subject: 'נושא',
    message: 'תוכן הפנייה',
    status: 'סטטוס',
    source: 'מקור',
    createdAt: 'נוצר בתאריך',
    // One label because it is one field now: the day and the hour are set
    // together, in the picker the phone already opens for both.
    meetingAt: 'מועד הפגישה',
    convertToLead: 'המרה לליד',
    converted: 'הפנייה הומרה לליד',
    deleteConfirm: 'למחוק את הפנייה? הפעולה אינה הפיכה.',
    bulkStatus: 'שינוי סטטוס',
    searchPlaceholder: 'חיפוש לפי שם, טלפון או נושא',
    reminderAt: 'תזכורת — מועד',
    reminderCreated: 'התזכורת נוצרה',
    reminderHint: 'תזכורת שתיווצר כאן תופיע גם במסך התזכורות.',
    // The agent does not answer calls yet (05.10): this tab only stores its
    // settings, so every line here says "בקרוב" rather than promise a live one.
    tabs: { inquiries: 'פניות', agents: 'סוכנים (בקרוב)' },
    agentsBody:
      'בקרוב: הסוכן יענה למספר הווירטואלי שלך, ישאל את השאלות שתגדיר ויפתח פנייה מהתשובות. אפשר כבר עכשיו להגדיר אותו.',
    agentsCount: 'סוכנים ({{count}})',
    agentNew: 'צור סוכן חדש',
    agentEdit: 'עריכת סוכן',
    agentName: 'שם העוזר/ת',
    agentNamePlaceholder: 'למשל: עמית',
    agentVoice: 'קול',
    agentNumber: 'מספר טלפון וירטואלי',
    agentNumberPick: 'בחר מספר…',
    agentNoNumbers: 'אין עדיין מספר וירטואלי לעסק. אפשר להקצות מספר באזור האישי, ואז לשייך אותו לסוכן.',
    agentForwardTo: 'שייך למספר',
    agentForwardToPlaceholder: 'מספר הטלפון שלך',
    agentTrade: 'תחום העסק',
    agentTradePlaceholder: 'למשל: שיפוצים ובנייה',
    agentSpecialties: 'סוגי התמחות',
    agentSpecialtiesPlaceholder: 'למשל: מטבחים, חדרי אמבטיה',
    agentInbound: 'שאלות לשיחה נכנסת (AI)',
    agentOutbound: 'שאלות לשיחה יוצאת (AI)',
    agentQuestionsPlaceholder: 'שאלה אחת בכל שורה',
    agentActive: 'עוזר פעיל',
    agentNoTrades: 'לא הוגדרו תחומי עיסוק',
    agentNoNumber: 'לא שויך מספר',
    agentDeleteConfirm: 'למחוק את הסוכן? השיחות שכבר נענו נשמרות, והמספר משתחרר לסוכן אחר.',
    agentsEmpty: 'עדיין לא הוגדר סוכן',
    agentsEmptyBody: 'בקרוב: סוכן יענה במקומך למספר של העסק, ישאל את מה שחשוב לך לדעת ויפתח פנייה מהתשובות.',
    agentSaved: 'הסוכן נשמר',
    emptyTitle: 'עדיין אין פניות',
    emptyBody: 'פניות ייקלטו אוטומטית משיחות ומהמיני-סייט, או שאפשר להוסיף ידנית.',
  },
  /*
   * What a customer is called wherever their details are shown — on a quote, in
   * a lead, in the team form. The customer card itself is gone, and the labels
   * that only it used went with it.
   */
  customer: {
    addContactValue: 'הוספת ערך',
    name: 'שם',
    phone: 'טלפון',
    email: 'אימייל',
    city: 'יישוב',
    /*
     * LEAD-004 — המספר שכבר רשום על כרטיס אחר. הטקסט אומר את שני השמות
     * במפורש, כי המשתמש לא בהכרח זוכר על מי המספר הזה שמור אצלו, ולכל בחירה
     * יש שורת הסבר משלה: אחת מהן משנה שם גם על מסמכים שכבר נשלחו.
     */
    match: {
      body: 'המספר {{phone}} כבר רשום אצלכם על הכרטיס של "{{name}}".',
      update: 'לעדכן ל"{{name}}"',
      keep: 'להמשיך עם "{{name}}"',
      new: 'כרטיס נפרד',
      updateHint: 'הפרטים שהקלדתם יוחלפו בכרטיס. השם יופיע גם על הצעות ומסמכים קודמים של אותו לקוח.',
      keepHint: 'הפרטים שהקלדתם לא יישמרו, והמסמך ייצא על שם "{{name}}".',
      newHint: 'ייפתח כרטיס שני עם אותו מספר. שיחה נכנסת מהמספר תקושר לכרטיס הראשון.',
      required: 'בחרו מה לעשות עם המספר לפני השמירה.',
    },
  },

  quotes: {
    saveChanges: 'שמירת שינויים',
    customFollowUpHours: 'מעקב מותאם (1–720 שעות)',
    projectLocation: 'מיקום הפרויקט',

    revisionChanged: 'ההצעה השתנתה מאז שפתחתם אותה. טעינת הגרסה העדכנית תחליף את השינויים שלא נשמרו.',
    reloadLatest: 'טעינת הגרסה העדכנית',
    attachAlbums: 'צירוף אלבומים',
    selectAlbums: 'בחרו אלבום אחד או יותר',
    attachedAlbums: 'אלבומים מצורפים',
    additionalProjects: 'פרויקטים נוספים של {{name}}',

    title: 'הצעות מחיר',
    one: 'הצעת מחיר',
    number: 'מספר הצעה',
    numberShort: 'הצעה #{{number}}',
    numberBadge: 'הצעת מחיר מס׳ {{number}}',
    new: 'הצעת מחיר חדשה',
    edit: 'עריכת הצעה',
    // אין יותר מסך לקוחות — החיפוש כאן הוא הדרך למצוא לקוח, אז הוא אומר לפי מה.
    searchPlaceholder: 'חיפוש לפי שם, טלפון או מספר הצעה',
    quoteTitle: 'כותרת ההצעה',
    customer: 'לקוח',
    items: 'פריטים',
    addItem: 'הוספת פריט',
    description: 'תיאור',
    quantity: 'כמות',
    unitPrice: 'מחיר ליחידה',
    lineTotal: 'סה"כ שורה',
    subtotal: 'סכום ביניים',
    included: 'כלול',
    discount: 'הנחה',
    discountType: 'סוג הנחה',
    discountNone: 'ללא הנחה',
    discountAmount: 'סכום קבוע',
    discountPercent: 'אחוזים',
    discountLabel: 'תיאור ההנחה',
    discountTemplates: 'תבניות הנחה',
    net: 'סכום לפני מע"מ',
    vat: 'מע"מ {{rate}}%',
    vatOfWhich: 'מתוכו מע"מ {{rate}}%',
    vatIncluded: 'המחירים כוללים מע"מ',
    total: 'סה"כ לתשלום',
    notes: 'הערות ללקוח',
    legalText: 'תנאים והסכם',
    legalTemplates: 'תבניות שמורות',
    insertTemplate: 'הוספת תבנית',
    saveAsTemplate: 'שמירה כתבנית',
    templateName: 'שם התבנית',
    deleteTemplate: 'מחיקת התבנית "{{name}}"',
    deleteTemplateConfirm: 'למחוק את התבנית "{{name}}"? הפעולה אינה הפיכה.',
    saveDraft: 'שמירה כטיוטה',
    sendQuote: 'שליחת הצעה',
    sendVia: 'שליחה באמצעות',
    email: 'אימייל',
    whatsapp: 'וואטסאפ',
    downloadPdf: 'הורדת PDF',
    copyLink: 'העתקת קישור',
    openPublicLink: 'פתיחת קישור הלקוח',
    sentAt: 'נשלח בתאריך',
    approvedAt: 'אושר בתאריך',
    rejectedAt: 'נדחה בתאריך',
    // 1.20 — how long the quote is good for, in days and never as a date.
    validFor_one: 'ההצעה בתוקף ליום אחד',
    validFor: 'ההצעה בתוקף ל-{{count}} ימים',
    createReminder: 'יצירת תזכורת',
    tracking: 'מעקב צפיות',
    viewCount: 'מספר צפיות',
    firstViewed: 'צפייה ראשונה',
    lastViewed: 'צפייה אחרונה',
    viewDuration: 'זמן צפייה מצטבר',
    notViewedYet: 'הלקוח עדיין לא פתח את ההצעה',
    notViewedShort: 'טרם נצפתה',
    viewedFor: 'נצפתה {{duration}}',
    rejectionReason: 'סיבת הדחייה',
    rangeLabel: 'תקופה',
    viewDocument: 'צפייה במסמך',
    duplicateForAnotherCustomer: 'שכפול הצעה ללקוח נוסף',
    fullDetails: 'פרטים מלאים',
    sendAgain: 'שלח שוב',
    draftDocument: 'הצעת מחיר (טיוטה)',
    toHonour: 'לכבוד',
    docDate: 'תאריך: {{date}}',
    serviceDescription: 'תיאור השירות',
    servicePlaceholder: 'פרט את השירות המוצע…',
    serviceTemplates: 'תבניות תיאור',
    notesPlaceholder: 'מה שחשוב שהלקוח ידע…',
    legalPlaceholder: 'תנאי תשלום, תקנון, הסכם…',
    discountValue: 'סכום ההנחה',
    preview: 'תצוגה מקדימה',
    noTemplates: 'אין תבניות שמורות',
    noItemsYet: 'לא נוספו פריטים',
    noVat: 'ללא מע״מ',
    totalWithVat: 'סה״כ לתשלום (כולל מע״מ)',
    totalNoVat: 'סה״כ לתשלום (ללא מע״מ)',
    producedBy: 'מסמך זה הופק באמצעות מערכת Worki',
    pricesIncludeVat: 'כולל מע״מ',
    pricesPlusVat: 'בתוספת מע״מ',
    sendChannels: 'ערוצי שליחה',
    sendOptions: 'ערוצי שליחה והגדרות',
    validDays: 'תוקף ההצעה',
    validDaysOption_one: 'יום אחד',
    validDaysOption: '{{count}} ימים',
    validDaysDefault: 'ברירת מחדל ({{count}} ימים)',
    vatOnQuote: 'מע״מ בהצעה זו',
    vatRateLabel: 'שיעור המע״מ',
    templateSaved: 'נשמר כתבנית',
    templateBody: 'תוכן התבנית',
    editTemplateTitle: 'עריכת תבנית',
    editTemplate: 'עריכת התבנית {{name}}',
    vatRateHint: 'ברירת המחדל היא שיעור המע״מ במערכת. שנו רק אם ההצעה הזו חייבת שיעור אחר.',
    vatRateReset: 'חזרה ל־{{rate}}%',
    followUp: 'תזכורת מעקב',
    hoursShort: '{{count}} שע׳',
    followUpDefault: 'לפי הגדרת העסק',
    followUpEvery_one: 'תזכורת אם לא נענתה תוך שעה',
    followUpEvery: 'תזכורת אם לא נענתה תוך {{count}} שעות',
    pickAChannel: 'בחרו לפחות ערוץ שליחה אחד',
    sendHistory: 'היסטוריית שליחות',
    sendMenu: 'אפשרויות שליחה',
    sendSettings: 'הגדרות שליחה',
    sendSettingsSaved: 'ההגדרה נשמרה',
    noSends: 'ההצעה עדיין לא נשלחה',
    sentTo: 'נשלחה אל {{to}}',
    notesTerms: 'הערות / תנאי השירות',
    itemTemplates: 'תבניות פריטים',
    removeItems: 'מחיקת פריטים — לחיצה רצופה לבחירה',
    removeSelectedItems: 'מחיקת הפריטים שנבחרו',
    doneSelecting: 'סיום הבחירה',
    dictate: 'הכתבה קולית',
    dictateStop: 'עצירת ההכתבה',
    // בסדר שבו הן מוצגות. "נשלחו" ירד: הוא כלל כל שורה חוץ מטיוטה, כלומר
    // כמעט את "הכל", והשאלה שבגללה פותחים את המסך היא מה עדיין ממתין לתשובה.
    // "ממתינות" הן ההצעות שבמצב "נשלחה", ולכן (1.26) השורה נושאת את שתי המילים,
    // כמו התג שלהן.
    tab: {
      all: 'הכל',
      pending: 'נשלחו/ממתינות',
      viewed: 'נצפו',
      expired: 'פג תוקף',
      rejected: 'נדחו',
      approved: 'נחתמו / אושרו',
      locked: 'ננעלו',
      draft: 'טיוטות',
    },
    deleteConfirm: 'למחוק את הצעת המחיר? הפעולה אינה הפיכה.',
    deleteSomeRefused_one: 'הצעה אחת לא נמחקה: הצעה שאושרה נשמרת כרשומה של ההסכם.',
    deleteSomeRefused: '{{count}} פריטים לא הוסרו. יש לרענן את הרשימה ולנסות שוב.',
    approvedNotDeletable: 'הצעה מאושרת נשמרת כרשומה ואינה נמחקת',
    cannotEditSent: 'לא ניתן לערוך הצעה שכבר נשלחה',
    emptyTitle: 'עדיין אין הצעות מחיר',
    emptyBody: 'צרו את ההצעה הראשונה ושלחו אותה ללקוח בלחיצה אחת.',
    sentSuccess: 'ההצעה נשלחה ללקוח',
    whatsappReady: 'הקישור מוכן — לחצו כדי לפתוח את וואטסאפ',
  },
  publicQuote: {
    revisionChanged: 'ההצעה עודכנה. טענו וקראו את הגרסה העדכנית לפני אישור.',
    reloadLatest: 'טעינת ההצעה העדכנית',
    from: 'הצעת מחיר מאת {{business}}',
    to: 'לכבוד {{name}}',
    // A customer deciding whether to approve now or next week has to be told
    // that the link stops working — the expiry existed but was never shown.
    validUntil: 'בתוקף עד {{date}}',
    approve: 'אישור ההצעה',
    reject: 'דחיית ההצעה',
    approveTitle: 'אישור הצעת מחיר',
    approveIntro: 'להשלמת האישור, הזינו את הקוד הבא:',
    yourCode: 'הקוד שלכם',
    codeHint: 'הקלידו את הקוד בשדה שלמטה כדי לאשר את ההצעה.',
    enterCode: 'הזנת קוד אישור',
    confirmApprove: 'אישור סופי',
    wrongCode: 'הקוד שהוזן שגוי. נסו שוב.',
    codeExpired: 'תוקף הקוד פג. התחילו את האישור מחדש.',
    approved: 'ההצעה אושרה בהצלחה',
    approvedBody: 'עותק חתום נשלח אליכם ולבעל העסק. תודה!',
    rejectTitle: 'דחיית הצעת מחיר',
    rejectIntro: 'נשמח להבין מה הסיבה:',
    rejectNote: 'הערה נוספת',
    confirmReject: 'שליחת הדחייה',
    rejected: 'הדחייה נקלטה',
    rejectedBody: 'תודה על המשוב. בעל העסק עודכן.',
    expiredTitle: 'תוקף ההצעה פג',
    expiredBody_one: 'הקישור להצעה זו היה בתוקף ליום אחד. פנו לבעל העסק לקבלת הצעה מעודכנת.',
    expiredBody: 'הקישור להצעה זו היה בתוקף ל-{{count}} ימים. פנו לבעל העסק לקבלת הצעה מעודכנת.',
    notFound: 'ההצעה לא נמצאה',
    generatedBy: 'הופק באמצעות Worki',
  },
  reminders: {
    openSource: 'פתיחת מסמך המקור',
    selectAllMatching: 'בחירת כל התזכורות ({{count}})',
    bulkComplete: 'סימון כהושלמו',
    bulkDeleteConfirm: 'למחוק {{count}} תזכורות שנבחרו?',
    mode: 'מה ליצור?', reminderTab: 'תזכורת', meetingTab: 'פגישה', newMeeting: 'פגישה חדשה',
    meetingTitle: 'נושא הפגישה', meetingCreationIncomplete: 'הפנייה נוצרה, אך קביעת הפגישה לא הושלמה. נסו שוב כדי להשלים אותה.',
    new: 'תזכורת חדשה',
    edit: 'עריכת תזכורת',
    reminderTitle: 'כותרת',
    notes: 'פירוט',
    dueAt: 'מועד',
    status: 'סטטוס',
    markComplete: 'סימון כבוצע',
    markOpen: 'החזרה לפתוחות',
    open: 'פתוח',
    overdue: 'באיחור',
    snoozeDay: 'דחייה ביום',
    snoozedUntil: 'ההתראה הבאה: {{date}}',
    fromDate: 'מתאריך',
    toDate: 'עד תאריך',
    emptyTitle: 'אין תזכורות',
    emptyBody: 'צרו תזכורת כדי לא לפספס מעקב אחרי לקוח או הצעה.',
    deleteConfirm: 'למחוק את התזכורת?',
    fromQuote: 'מהצעה #{{number}}',
    fromInquiry: 'מפנייה',
    fromCustomer: 'מכרטיס לקוח',
    searchPlaceholder: 'חיפוש בתזכורות ובפגישות…',
    previewOpen: 'הפריט פתוח וממתין לביצוע',
    previewDone: 'הפריט סומן כטופל',
    feed: {
      all: 'הכל',
      notification: 'התראות',
      reminder: 'תזכורות',
      meeting: 'פגישות',
      activity: 'פעילות',
    },
  },
  activity: {
    subtitle: 'כל פעולה במערכת מתועדת ואינה ניתנת לשינוי',
    actor: 'מבצע',
    action: 'פעולה',
    entity: 'רשומה',
    when: 'מתי',
    empty: 'אין פעילות מתועדת',
    viewAll: 'הצג את כל הפעילות',
  },
  reports: {
    title: 'דוחות וסטטיסטיקות',
    subtitle: 'ביצועים לפי תקופה, בכל המודולים',
    domains: {
      quotes: 'הצעות מחיר',
      inquiries: 'פניות',
      reminders: 'תזכורות',
      calls: 'שיחות',
      invoices: 'חשבוניות',
      // הכרטיס שמאגד שיחות, תזכורות וחשבוניות. קודם הוא נקרא 'כלים', שם שנשאר
      // מהתפריט הישן ולא אמר דבר על מה שיש בו.
      operations: 'תפעול',
      revenue: 'הכנסות',
    },
    // כרטיס ההכנסות. 'הכנסה בתקופה' ולא 'הכנסה חודשית' כמו בהדגמה — התקופה
    // כאן נבחרת בבורר שמעל הכרטיסים, וכותרת שכתוב בה 'חודשית' תשקר בכל בחירה
    // אחרת. 'עסקאות פתוחות' מוצג בשווי ולא במספר: הכמות כבר מופיעה בכרטיס
    // הצעות המחיר, והכסף שתלוי ועומד הוא מה שאין בשום מקום אחר.
    revenueApproved: 'הכנסה בתקופה',
    revenueAvgDeal: 'ממוצע לעסקה',
    revenueOpen: 'שווי עסקאות פתוחות',
    revenueGrowth: 'צמיחה מול התקופה הקודמת',
    /** Header row of the quotes export. Server-rendered, so it needs its own keys. */
    csv: {
      number: 'מספר הצעה',
      customer: 'לקוח',
      quoteTitle: 'כותרת ההצעה',
      status: 'סטטוס',
      currency: 'מטבע',
      subtotal: 'סכום ביניים',
      discount: 'הנחה',
      net: 'סכום לפני מע"מ',
      vatRate: 'שיעור מע"מ',
      vat: 'מע"מ',
      total: 'סה"כ לתשלום',
      totalFormatted: 'סה"כ מוצג',
      createdAt: 'נוצרה בתאריך',
      sentAt: 'נשלחה בתאריך',
      approvedAt: 'אושרה בתאריך',
      rejectedAt: 'נדחתה בתאריך',
      rejectionReason: 'סיבת הדחייה',
      viewCount: 'מספר צפיות',
    },
    conversionRate: 'שיעור המרה',
    avgResponseTime: 'זמן תגובה ממוצע',
    viewRate: 'שיעור צפייה',
    avgViewCount: 'צפיות בממוצע להצעה',
    avgViewDuration: 'זמן צפייה ממוצע',
    // The response time is one number in hours, but a customer who answers in
    // minutes and one who answers next week both deserve a readable figure, so
    // the unit follows the size of the value.
    responseMinutes_one: 'דקה אחת',
    responseMinutes: '{{count}} דקות',
    responseHours_one: 'שעה אחת',
    responseHours: '{{count}} שעות',
    responseDays_one: 'יום אחד',
    responseDays: '{{count}} ימים',
    reconcileNote: 'המספרים כאן זהים למספרי לוח הבקרה עבור אותה תקופה.',
    comparison: 'השוואה לתקופה קודמת',
    noComparison: 'אין השוואה עבור "מאז ומתמיד"',
    chart: 'מגמה לאורך זמן',
    quotesCreated: 'הצעות שנוצרו',
    quotesSent: 'הצעות שנשלחו',
    quotesApproved: 'הצעות שאושרו',
    // The comparison table renders one row per delta the API returns, and
    // `quotesRejected` is one of them — without a key of its own the row showed
    // the raw metric name in English.
    quotesRejected: 'הצעות שנדחו',
    inquiriesCreated: 'פניות שהתקבלו',
    metric: 'מדד',
    totalInquiries: 'סה״כ פניות',
    totalCalls: 'סה"כ שיחות',
    inquiriesMeetings: 'פניות שהבשילו לפגישה',
    inquiriesQuoteRequested: 'פניות שביקשו הצעת מחיר',
    closeRate: 'יחס סגירה',
    openReminders: 'פתוחות',
    exportCsv: 'ייצוא ל-CSV',
    noData: 'אין נתונים עדיין עבור התקופה שנבחרה',
    vsLastPeriod: 'לעומת התקופה הקודמת',
  },
  invoices: {
    forwarding: {
      title: 'שליחה אוטומטית של חשבוניות', addRule: 'הוספת שליחה אוטומטית', empty: 'טרם הוגדרה שליחה אוטומטית',
      recipientEmail: 'דוא״ל הנמען', fromDay: 'מתאריך', toDay: 'עד תאריך',
      dateHint: 'טווח תאריכים קבוע, כולל תאריך ההתחלה והסיום. נשלחות חשבוניות שהגיעו מהדוא״ל בלבד.',
      delivery: 'אופן השליחה', pdf: 'קובץ PDF', link: 'קישור', folder: 'תיקייה', account: 'חשבון דוא״ל',
      retryUnsent: 'אפשר ניסיון נוסף לחשבוניות שלא נשלחו',
      retryHint: 'חשבוניות שנכשלו לפני שליחה או דולגו יוחזרו לתצוגה המקדימה. פעולה זו אינה שולחת. שליחות שמצב הקבלה שלהן אינו ידוע נשארות חסומות.',
      skippedCount: '{{count}} חשבוניות דולגו',
      allFolders: 'כל התיקיות', allAccounts: 'כל חשבונות הדוא״ל', intervalMinutes: 'תדירות בדיקה בדקות',
      savePreview: 'שמירה בהשהיה ובדיקת השליחה', previewTitle: 'בדיקת הגדרת השליחה',
      sentCount: '{{count}} חשבוניות נשלחו', failedCount: '{{count}} חשבוניות נכשלו', uncertainCount: '{{count}} חשבוניות דורשות בדיקת מסירה',
      matchedCount: '{{count}} חשבוניות בטווח', pendingCount: '{{count}} חשבוניות חדשות לשליחה', blockedCount: '{{count}} חשבוניות דורשות בדיקה',
      enableHint: 'הפעלה תשלח אוטומטית חשבוניות חדשות שיתגלו בטווח הזה. שינוי ההגדרה לא ישלח שוב חשבוניות שכבר טופלו. לשליחה חוזרת לנמען אחר, צרו הגדרה חדשה.',
      enable: 'הפעלת שליחה אוטומטית', pause: 'השהיה', enabled: 'פעילה', paused: 'מושהית', edit: 'עריכת ההגדרה', delete: 'מחיקת ההגדרה',
      runNow: 'שליחת החשבוניות החדשות כעת', runs: 'היסטוריית השליחות', noRuns: 'עדיין לא בוצעה שליחה',
      pending: 'ממתינה', running: 'בתהליך', completed: 'נשלחה', failed: 'נכשלה', uncertain: 'נדרשת בדיקת מסירה',
      uncertainHint: 'ייתכן שהדוא״ל נמסר. בדקו עם הנמען לפני שליחה ידנית נוספת כדי למנוע כפילות.',
      previewRequired: 'בדקו את התצוגה המקדימה לפני הפעלת השליחה', lastRun: 'הבדיקה האחרונה', missingTotal: 'לחלק מהחשבוניות אין סכום מזוהה',
    },
    removeFromFolder: 'הסרה מהתיקייה',
    removeFromFolderConfirm: 'להסיר את החשבוניות שנבחרו מהתיקייה? החשבוניות יישארו במאגר.',
    connectAccount: 'חיבור חשבון מייל',
    status: 'סטטוס',
    lastSync: 'סנכרון אחרון',
    disconnect: 'ניתוק',
    disconnectConfirm: 'לנתק את {{email}}? {{count}} החשבוניות שנסרקו מהתיבה יימחקו יחד עם הקבצים שלהן, ואי אפשר לשחזר אותן.',
    disconnectConfirmCounting: 'לנתק את {{email}}? החשבוניות שנסרקו מהתיבה יימחקו יחד עם הקבצים שלהן, ואי אפשר לשחזר אותן.',
    maxAccountsReached: 'הגעתם למגבלה של 2 חשבונות מייל. יש לנתק חשבון קיים כדי לחבר חדש.',
    accountConnected: 'החשבון חובר בהצלחה',
    statusActive: 'פעיל',
    statusError: 'שגיאת סנכרון',
    /* INV-010 — logging in to a mailbox again, without disconnecting it. */
    statusReconnect: 'נדרשת התחברות',
    reconnect: 'התחברות מחדש',
    reconnectTitle: 'התחברות מחדש ל-{{email}}',
    reconnectHint:
      'החיבור לתיבה פג, ולכן הסנכרון נעצר. אחרי ההתחברות הסנכרון ימשיך מאיפה שעצר. החשבוניות והתיקיות נשארות במקומן, ואין צורך לנתק את התיבה.',
    reconnectWithGoogle: 'התחברות עם Google',
    reconnectWithMicrosoft: 'התחברות עם Microsoft',
    reconnectPasswordHint: 'הזינו את סיסמת האפליקציה של התיבה. אם הסיסמה הקודמת בוטלה, צרו חדשה אצל ספק הדואר.',
    accountReconnected: 'התיבה חוברה מחדש, והסנכרון ממשיך',
    disconnectInsteadOfReconnect: 'כדי לחדש את החיבור בלי למחוק דבר, סגרו את החלון ובחרו "התחברות מחדש".',
    oauthWrongMailbox: 'במסך ההתחברות נבחרה תיבה אחרת מזו שמחברים מחדש. נסו שוב ובחרו באותה תיבה.',
    number: 'מספר',
    issuedAt: 'תאריך הפקה',
    receivedAt: 'התקבל בדוא"ל',
    addedAt: 'נוסף ל־Worki',
    folderFiltered: 'מוצגות {{visible}} מתוך {{count}} חשבוניות בתיקייה. סינונים נוספים פעילים.',
    showAllInFolder: 'הצגת כל חשבוניות התיקייה',
    fromAccount: 'התקבל בחשבון',
    source: 'מקור המסמך',
    sourceAttachment: 'קובץ מצורף למייל',
    fromLink: 'נמשך מלינק',
    /* Short enough to sit on a row next to the account and the date. */
    sourceBadgeLink: 'לינק',
    sourceBadgeFile: 'קובץ',
    sourceBadgeManual: 'נוספה ידנית',
    fromLinkNote: 'המייל הכיל לינק ולא קובץ. זהו עותק שהמערכת הורידה או הדפיסה מהדף.',
    download: 'הורדה',
    emptyTitle: 'אין חשבוניות עדיין',
    emptyBody: 'חברו חשבון מייל וחשבוניות חדשות ייקלטו אוטומטית.',
    deleteConfirm: 'למחוק את החשבונית? הפעולה אינה הפיכה.',
    deleteSelectedConfirm_one: 'למחוק את החשבונית שנבחרה? הפעולה אינה הפיכה.',
    deleteSelectedConfirm: 'למחוק {{count}} חשבוניות שנבחרו? הפעולה אינה הפיכה.',
    deleteSomeRefused_one: 'חשבונית אחת לא נמחקה.',
    deleteSomeRefused: '{{count}} חשבוניות לא נמחקו.',
    allAccounts: 'כל החשבונות',
    syncNow: 'סנכרון עכשיו',
    resetAll: 'מחיקת הכל וסריקה מחדש',
    resetAllConfirm:
      'כל החשבוניות ברשימה יימחקו יחד עם הקבצים השמורים שלהן, ומיד לאחר מכן תתחיל סריקה מחדש של ארבע השנים האחרונות בכל תיבות הדואר המחוברות. חשבונית שהמייל שלה כבר מחוץ לארבע השנים האחרונות לא תחזור. הפעולה אינה הפיכה.',
    resetAllAction: 'מחיקה וסריקה',
    resetAllDone_one: 'חשבונית אחת נמחקה, הסריקה החלה',
    resetAllDone: '{{count}} חשבוניות נמחקו, הסריקה החלה',
    connect: 'חבר',
    connectHint: 'חברו עד {{max}} חשבונות לסנכרון',
    searchPlaceholder: 'חיפוש לפי ספק, מייל או סכום…',
    count_one: 'חשבונית אחת',
    count: '{{count}} חשבוניות',
    detailTitle: 'פרטי חשבונית',
    synced_one: 'סונכרנה חשבונית חדשה אחת',
    synced: 'סונכרנו {{count}} חשבוניות חדשות',
    demoProviderNote: 'במצב פיתוח: כל כתובת מייל מתחברת דרך ספק הדגמה (להגדרת תיבה אמיתית: INVOICE_SYNC_DRIVER=imap).',
    notSyncedYet: 'עדיין לא סונכרן',
    mailProvider: 'ספק דואר',
    customImap: 'אחר (IMAP מותאם)',
    imapHost: 'שרת IMAP',
    imapPort: 'פורט',
    appPassword: 'סיסמת אפליקציה',
    appPasswordHint:
      'יש להשתמש בסיסמת אפליקציה ולא בסיסמת החשבון. ב-Gmail: חשבון Google ← אבטחה ← סיסמאות אפליקציות. ב-Outlook: אבטחה ← אפשרויות אבטחה מתקדמות.',
    imapCredentialsRequired: 'נדרשים שרת IMAP וסיסמת אפליקציה',
    imapAppPasswordRequired:
      'גוגל דורשת סיסמת אפליקציה, לא סיסמת החשבון הרגילה. צרו אחת ב-Google → אבטחה → סיסמאות אפליקציות והדביקו אותה כאן.',
    imapAuthFailed: 'המייל או סיסמת האפליקציה שגויים. נסו שוב.',
    imapConnectFailed: 'ההתחברות לתיבת המייל נכשלה. בדקו את כתובת שרת ה-IMAP ואת הפורט.',
    scanFailed: 'הסריקה לא הצליחה להסתיים. הרשומות שכבר יובאו נשמרו. נסו להפעיל את הסריקה שוב.',
    connectWithGoogle: 'חיבור עם Google',
    connectWithMicrosoft: 'חיבור עם Microsoft',
    oauthHint: 'אישור במסך של הספק, בלי סיסמת אפליקציה. Worki מקבל הרשאת קריאה בלבד, וניתן לבטל אותה בכל רגע מהחשבון שלכם אצל הספק.',
    orAppPassword: 'או חיבור עם סיסמת אפליקציה',
    oauthFailed: 'חיבור תיבת הדואר נכשל. נסו שוב.',
    oauthCancelled: 'החיבור בוטל, ותיבת הדואר לא נוספה.',
    oauthDisabled: 'חיבור בלחיצה אינו זמין בשרת הזה.',
    oauthReconnectRequired: 'ההרשאה לתיבת הדואר פגה או בוטלה. התחברו מחדש כדי להמשיך לסנכרן.',
    oauthNoOfflineAccess:
      'ההרשאה ניתנה בלי גישה מתמשכת, כך שהסנכרון היה נפסק תוך שעה. נסו שוב ואשרו את כל ההרשאות שהספק מבקש.',
    oauthConnectOnly: 'תיבה מסוג זה מתחברת במסך האישור של הספק, לא בטופס הזה.',
    rangeLabel: 'תקופה',
    range: {
      week: 'השבוע',
      month: 'החודש',
      twoMonths: 'החודשיים האחרונים',
      year: 'השנה',
      all: 'כל התקופות',
    },
    period: {
      custom: 'או בחירת תאריכים',
      fromDay: 'מ-{{day}}',
      untilDay: 'עד {{day}}',
      yearsCount: '{{count}} שנים',
      fromLabel: 'מתאריך',
      toLabel: 'עד תאריך',
      clearCustom: 'ניקוי התאריכים',
    },
    share: 'שיתוף',
    folders: 'תיקיות',
    // Where a selection is filed, the choice that takes it out of every folder.
    // The folder menu no longer lists it as a filter (1.10).
    noFolder: 'ללא תיקייה',
    // The dropdown before a single folder has been made. It says so in the
    // list rather than leaving the icon looking broken.
    noFoldersYet: 'לא קיימות תיקיות',
    manageFolders: 'ניהול תיקיות',
    newFolder: 'תיקייה חדשה',
    // 1.10 — the plus beside "תיקיות" in the folder menu.
    createFolderAction: 'יצירת תיקייה חדשה',
    folderName: 'שם התיקייה',
    moveToFolder: 'העברה לתיקייה',
    // 1.13 — the choice in that menu that makes the folder first. It asks for the
    // name, hence the dots, and the button that answers it says both things it does.
    moveToNewFolder: 'תיקייה חדשה…',
    createAndMove: 'יצירה והעברה',
    moved_one: 'חשבונית אחת הועברה',
    moved: '{{count}} חשבוניות הועברו',
    deleteFolder: 'מחיקת תיקייה',
    // 1.10 — the manage dialog's questions. There is no unfiled list to send the
    // invoices back to any more: they stay where they are, without a folder.
    deleteFolderConfirm: 'החשבוניות שבתיקייה לא יימחקו — הן יישארו ברשימת החשבוניות, בלי תיקייה.',
    // 10.1 — the bin in the folder menu. It names the folder, because it is
    // pressed in a list of them, and says the invoices stay: the server takes
    // them out of the folder and deletes none of them.
    deleteFolderNamed_zero: 'למחוק את התיקייה "{{name}}"? אין בה חשבוניות.',
    deleteFolderNamed_one: 'למחוק את התיקייה "{{name}}"? החשבונית שבה לא תימחק — היא תישאר ברשימת החשבוניות, בלי תיקייה.',
    deleteFolderNamed: 'למחוק את התיקייה "{{name}}"? {{count}} החשבוניות שבה לא יימחקו — הן יישארו ברשימת החשבוניות, בלי תיקייה.',
    emptyFolder: 'ריקון התיקייה',
    emptyFolderAction: 'ריקון',
    // The count is in the question because "empty it" reads the same for two
    // invoices and for two hundred, and the two are not the same decision.
    emptyFolderConfirm_one: 'החשבונית שבתיקייה תוצא ממנה ותישאר ברשימת החשבוניות, בלי תיקייה. התיקייה עצמה תישאר, ושום חשבונית לא תימחק.',
    emptyFolderConfirm: '{{count}} החשבוניות שבתיקייה יוצאו ממנה ויישארו ברשימת החשבוניות, בלי תיקייה. התיקייה עצמה תישאר, ושום חשבונית לא תימחק.',
    emptied_one: 'חשבונית אחת הוצאה מהתיקייה',
    emptied: '{{count}} חשבוניות הוצאו מהתיקייה',
    // The number is the whole point: it is how someone sees that "select all"
    // has taken the folder and not the page they are looking at.
    selectAllMatching: 'בחירת כל {{count}} התוצאות',
    // The other choice beside it, in Nitzan's words (1.10). Its number is the rows
    // on this page, so the two counts say which of the two is the smaller one.
    selectPageOnly: 'בחירת העמוד בלבד ({{count}})',
    selectionCapped: 'אפשר לבחור עד {{count}} חשבוניות בפעולה אחת. נבחרו הראשונות — אפשר לצמצם את הסינון ולשלוח בשתי מנות.',
    shareTitle: 'שיתוף חשבוניות',
    shareHint: 'החשבוניות שנבחרו יאוחדו לקובץ PDF אחד.',
    sharePartial: 'חלק מערוצי השליחה נכשלו. השליחות שהצליחו תועדו. בדקו את המסירה לפני ניסיון נוסף בערוצים שנותרו.',
    recipientLanguage: 'שפת הנמען',
    shareFileTitle: 'כותרת הקובץ',
    shareFileTitleHint: 'לדוגמה: חשבוניות ספטמבר 2026',
    shareFolderTitle: 'שיתוף תיקייה — {{name}}',
    shareFolderAction: 'שיתוף התיקייה',
    folderSentAt: 'נשלח {{date}} {{time}}',
    renameFolderAction: 'שינוי שם התיקייה',
    shareInvoiceTitle: 'שיתוף חשבונית — {{name}}',
    shareRowAction: 'שליחת החשבונית',
    shareFolders_one: 'שיתוף תיקייה',
    shareFolders: 'שיתוף {{count}} תיקיות',
    sharePhoneHint: 'אפשר להשאיר ריק — וואטסאפ ייפתח לבחירת איש קשר',
    shareSent: 'החשבוניות נשלחו',
    shareSentLink: 'הקובץ גדול מדי לצירוף למייל — נשלח קישור להורדה במקום',
    shareReady: 'וואטסאפ נפתח עם קישור לקובץ',
    shareSkipped_one: 'חשבונית אחת לא נכללה בקובץ — לא נמצא עבורה מסמך קריא',
    shareSkipped: '{{count}} חשבוניות לא נכללו בקובץ — לא נמצא עבורן מסמך קריא',
    // 1.9 — the mail carries the file or a link to it, chosen in the dialog before
    // it goes. The two names are Nitzan's: "PDF" and "קישור".
    shareDelivery: 'אופן השליחה',
    shareAsPdf: 'PDF',
    shareAsLink: 'קישור',
    // Under the choice while the PDF is greyed out: the merged file is over what a
    // mail can carry, so the link is what goes.
    sharePdfTooBig: 'הקבצים גדולים מדי לצירוף למייל',
    pickMonth: 'חודש',
    pickYear: 'שנה',
    // לא "כל התקופות": זה בדיוק מה שכתוב בתיבה שלידה, ושתי תיבות עם אותה
    // מילה נראות כמו אותה תיבה פעמיים.
    allYears: 'הכל',
    anyMonth: 'כל החודשים',
    totalSpent: 'סך החשבוניות',
    // 1.14 — above the figures while invoices are ticked: whose they are.
    summarySelected_one: 'סה״כ לחשבונית אחת שנבחרה',
    summarySelected: 'סה״כ ל-{{count}} חשבוניות שנבחרו',
    vatCredit: 'מע״מ להחזר',
    vatCreditHint: 'לפי {{rate}}% מע״מ',
    // INV-007 — the credit rests on the tax invoices alone, and the gap
    // between that count and the period's is what makes the figure believable.
    vatCreditFrom_one: 'מחשבונית מס אחת מתוך {{total}}',
    vatCreditFrom: 'מ-{{count}} חשבוניות מס מתוך {{total}}',
    // Round 3 — behind the "i" beside the credit. Only tax invoices in shekels count.
    vatCreditInfo:
      'הערכה של המע״מ שאפשר לקזז, לפי שיעור המע״מ הנוכחי. היא מחושבת רק מחשבוניות מס בשקלים — קבלות, חשבונות עסקה והכנסות לא נספרות. את הסכום הסופי סוגרים עם רואה החשבון.',
    // Round 3 — behind the "i" beside the move-to-folder menu in the selection bar.
    foldersInfo:
      'תיקייה מקבצת חשבוניות, למשל לפי חודש או בשביל רואה החשבון. חשבונית שהועברה לתיקייה נשארת גם ברשימת החשבוניות הרגילה.',
    // Round 3 — in the share dialog, when a whole folder is being sent.
    shareFolderInfo:
      'כל החשבוניות שבתיקייה יוצאות יחד, כקובץ PDF אחד או כקישור אליו, למי שתבחרו. אחרי השליחה מופיע ליד התיקייה מתי היא נשלחה.',
    // Under the credit whenever the credit is shown: the figure is worked out
    // from what the scan read, and it is one someone might carry into a return.
    vatDisclaimer: '*חישוב המע״מ לצורך המחשה בלבד, ואינו מהווה תחליף לייעוץ מקצועי.',
    missingAllocation_one:
      'חשבונית מס אחת חייבת מספר הקצאה לפי תאריכה ואינה נושאת אותו — רשות המסים לא תאפשר לקזז את המע״מ שלה.',
    missingAllocation:
      '{{count}} חשבוניות מס חייבות מספר הקצאה לפי תאריכן ואינן נושאות אותו — רשות המסים לא תאפשר לקזז את המע״מ שלהן.',
    docType: {
      tax_invoice: 'חשבונית מס',
      tax_invoice_receipt: 'חשבונית מס/קבלה',
      en_tax_invoice: 'חשבונית מס באנגלית',
      receipt: 'קבלה',
      proforma: 'חשבון עסקה',
      credit_note: 'הודעת זיכוי',
      not_yet_tax_invoice: 'טרם חשבונית מס',
      en_invoice: 'לא חשבונית מס',
      other: 'סוג לא זוהה',
    },
    docTypeFilter: 'סוג מסמך',
    docTypeFilterAll: 'כל סוגי המסמכים',
    docTypeSelected_one: 'סוג אחד',
    docTypeSelected: '{{count}} סוגים',
    // 1.5 — the five choices the filter offers, in Nitzan's words and his order.
    // They name what a person looks for, not the types behind them: the credit
    // note is "חשבונית זיכוי" here and still "הודעת זיכוי" on its own row.
    docTypeOption: {
      taxInvoiceReceipt: 'חשבונית מס/קבלה',
      receipt: 'קבלה',
      creditNote: 'חשבונית זיכוי',
      english: 'חשבונית באנגלית',
      unrecognised: 'לא מזוהה',
    },
    fromInvoiceCount: 'מתוך {{count}} חשבוניות',
    invoiceCount_one: 'חשבונית אחת',
    invoiceCount: '{{count}} חשבוניות',
    missingAmount_one: 'בחשבונית אחת לא נקרא הסכום',
    missingAmount: '{{count}} חשבוניות לא נקראו',
    missingAmountShow_one: 'הצגתה',
    missingAmountShow: 'הצגתן',
    missingAmountFilter: 'ללא סכום שנקרא',
    missingAmountEmpty: 'בכל החשבוניות בתקופה הזו נקרא הסכום.',
    clearFilter: 'ניקוי',
    scanning: 'סורק את תיבת המייל',
    scanSearching: 'עוברים על הדואר מארבע שנים אחורה…',
    scanExamined: 'נבדקו {{examined}} הודעות…',
    scanProgress: '{{scanned}} מתוך {{total}} הודעות',
    scanFound_one: 'נמצאה חשבונית אחת',
    scanFound: 'נמצאו {{count}} חשבוניות',
    elapsed: '{{seconds}} שנ׳',
    remaining: 'נותרו {{time}}',
    secondsShort_one: 'שנייה',
    secondsShort: '{{count}} שנ׳',
    minutesShort_one: 'כדקה',
    minutesShort: 'כ־{{count}} דק׳',
    syncedNone: 'לא נמצאו חשבוניות חדשות',
    syncStalled: 'הסריקה נעצרה באמצע. אפשר להפעיל אותה שוב — מה שכבר נקלט נשמר.',
    syncRateLimited: 'גוגל הגביל את קצב הקריאה מהתיבה. חכו כמה דקות והפעילו את הסריקה שוב — מה שכבר נקלט נשמר.',
    // Section 5 (05.10) — an invoice the business wrote. The badge on its row,
    // the name on it (the customer, where an expense names the supplier), and
    // the two figures beside the expenses in the bar: never added to them.
    income: 'הכנסה',
    customer: 'לקוח',
    incomeTotal: 'הכנסות',
    incomeVat: 'מע״מ עסקאות',
    incomeShareLine: '{{count}} חשבוניות · הכנסות: {{total}} · מע״מ עסקאות ({{rate}}%): {{vat}}',
  },
  profile: {
    resetColors: 'צבעי המקור',
    saveSettings: 'שמירת השינויים',
    settingsSaved: 'ההגדרות נשמרו',
    invertColors: 'היפוך צבעים',
    borderIntensity: 'עוצמת המסגרות',
    planContents: 'תכולת החבילה והמכסה שנותרה',
    // מכסה בלי תקרה עדיין צריכה מונה: בלעדיו החבילה שכל כולה "בלי הגבלה"
    // היא היחידה שלא אומרת כמה נוצל ממנה.
    planUsed: 'בשימוש {{used}}',
    // כותרת הבלוק שעבר מפרטי המנוי ללשונית ההגדרות.
    remindersAndCurrency: 'תזכורות ומטבע',

    // אדם אחד נרשם ומנהל עסק אחד — הפרטים שלו ושל העסק הם כרטיס אחד.
    subscriber: 'פרטי המנוי',
    // חצי משפט לצד שם העסק בראש ההצעה — "מסגרות ואלומיניום, 20 שנות ניסיון".
    // לא ה"אודות" של המיני-סייט, שהוא פסקה שקוראים ולא שורה שמודפסת.
    slogan: 'סלוגן',
    quoteFooter: 'טקסט תחתית להצעות',
    virtualNumber: 'מספר וירטואלי',
    virtualNumberHint: 'המספר שספק הטלפוניה מנתב אליכם. שיחות נכנסות אליו יתועדו במסך השיחות.',
    provisionNumber: 'הקצאת מספר',
    provisionNumberConfirm: 'להזמין מספר חדש מספק הטלפוניה? המספר מחויב בתשלום חודשי בחשבון הספק.',
    provisionNumberDone: 'המספר הוקצה ושויך אליכם',
    deleteAccount: 'מחיקת חשבון',
    deleteAccountBody:
      'מוחק את החשבון שלכם ואת כל מה שתויק תחתיו. אם אף אחד אחר לא משתמש בעסק הזה, גם העסק נמחק — לקוחות, הצעות, חשבוניות, תיק עבודות וקבצים. אין דרך חזרה.',
    deleteAccountLearnMore: 'מה בדיוק נמחק, ומה נשמר',
    deleteAccountWarning:
      'אי אפשר לבטל את הפעולה. אחרי המחיקה הנתונים אינם, ולא נוכל לשחזר אותם — לא מגיבוי ולא לבקשה.',
    deleteAccountConfirmLabel: 'הקלידו {{email}} לאישור',
    deleteAccountConfirm: 'מחיקה לצמיתות',
    deleteAccountDone: 'החשבון שלכם נמחק',
    taxId: 'ח.פ. / ע.מ.',
    currency: 'מטבע',
    address: 'כתובת',
    quoteReminderHours: 'תזכורת מעקב ללא מענה (שעות)',
    // בתצוגה, המספר לבדו אינו אומר במה מדובר.
    quoteReminderHoursValue_one: 'שעה אחת',
    quoteReminderHoursValue: '{{count}} שעות',
    quoteReminderHoursHint: 'אם הלקוח לא ענה להצעה תוך שעות אלה מיום השליחה, נוצרת תזכורת מעקב. לינק ההצעה תקף 7 ימים, לכן המקסימום הוא 168.',
    signatureReminderHours: 'תזכורת מעקב על מסמך שלא נחתם (שעות)',
    signatureReminderHoursValue_one: 'שעה אחת',
    signatureReminderHoursValue: '{{count}} שעות',
    signatureReminderHoursHint: 'אם המסמך לא נחתם תוך שעות אלה מיום השליחה, נוצרת תזכורת מעקב. קישור החתימה תקף 30 יום, לכן המקסימום הוא 720.',
    saved: 'הפרטים נשמרו',
    plan: 'החבילה שלי',
    settings: 'הגדרות',
    allDetails: 'כל פרטי העסק',
    editDone: 'סיום',
    appearance: 'מצב תצוגה',
    listGradient: 'עוצמת גרדיאנט ברשימות',
    listGradientHint: 'מ-0 (שורות שטוחות) עד 100. הגוון נלקח מצבע המערכת שנבחר למעלה.',
    light: 'בהיר',
    dark: 'כהה',
    reports: 'דוחות וסטטיסטיקות',
    reportsRange: 'החודש הנוכחי',
    reportsOpen: 'לדוחות המלאים',
    admin: 'אדמין',
    adminBody: 'ניהול הפלטפורמה של Worki — עסקים, מנויים, חבילות וצוות. גלוי לצוות Worki בלבד.',
    adminOpen: 'פתיחת מסך האדמין',
  },
  notifications: {
    title: 'התראות',
    empty: 'אין התראות חדשות',
    markAllRead: 'סימון הכל כנקרא',
    quoteOpened: 'הלקוח {{customer}} פתח את הצעה #{{number}}',
    quoteApproved: 'הצעה #{{number}} אושרה על ידי {{customer}}',
    quoteRejected: 'הצעה #{{number}} נדחתה על ידי {{customer}}',
    inquiryCreated: 'התקבלה פנייה חדשה מ-{{customer}}',
    reminderDue: 'הגיע מועד התזכורת: {{title}}',
    openReminders: '{{count}} תזכורות פתוחות',
    openRemindersHint: 'מעבר לרשימת התזכורות',
  },
  enum: {
    callStatus: { answered: 'נענתה', missed: 'לא נענתה', callback: 'שיחה חוזרת' },
    agentVoice: {
      female: 'אישה',
      male: 'גבר',
    },
    inquiryStatus: {
      pending: 'ממתין לטיפול',
      meeting_scheduled: 'נקבעה פגישה',
      quote_requested: 'ביקש הצעת מחיר',
      closed: 'נסגר',
    },
    inquirySource: {
      manual: 'הזנה ידנית',
      telephony: 'שיחת טלפון',
      mini_site: 'מיני-סייט',
      integration: 'אינטגרציה',
    },
    quoteStatus: {
      draft: 'טיוטה',
      sent: 'נשלחה/בהמתנה',
      approved: 'אושרה',
      rejected: 'נדחתה',
      expired: 'פג תוקף',
    },
    rejectionReason: {
      price: 'המחיר גבוה מדי',
      better_offer: 'התקבלה הצעה טובה יותר',
      improve_terms: 'רוצה לשפר את התנאים',
      not_relevant: 'לא רלוונטי יותר',
    },
    reminderStatus: {
      open: 'פתוח',
      completed: 'בוצע',
    },
    reminderSource: {
      manual: 'ידני',
      quote: 'הצעת מחיר',
      inquiry: 'פנייה',
      customer: 'לקוח',
      call: 'שיחה',
    },
    /**
     * The activity log falls back to the entity type whenever an entry carries
     * no name or number of its own — every reminder, invoice and mail-account
     * row did, so a Hebrew table listed "reminder" and "connected_mail_account".
     */
    entityType: {
      customer_payment: 'תשלום לקוח',
      ai_agent: 'סוכן טלפוני',
      business: 'עסק',
      call: 'שיחה',
      connected_mail_account: 'חשבון מייל',
      customer: 'לקוח',
      gallery: 'גלריה',
      gallery_image: 'תמונה בגלריה',
      inquiry: 'פנייה',
      invoice: 'חשבונית',
      invoice_bundle: 'קובץ חשבוניות משותף',
      invoice_folder: 'תיקיית חשבוניות',
      lead: 'ליד',
      library_document: 'מסמך בספרייה',
      mini_site: 'מיני-סייט',
      offer: 'מבצע',
      plan: 'מסלול מנוי',
      quote: 'הצעת מחיר',
      reminder: 'תזכורת',
      review: 'חוות דעת',
      setting: 'הגדרות המערכת',
      signature_document: 'מסמך להחתמה',
      template: 'תבנית',
      trade: 'תחום עיסוק',
      user: 'משתמש',
    },
    /**
     * Anything the product itself did is recorded under a fixed English label —
     * the public mini-site, the telephony webhook, the expiry job. Users saw
     * those raw. Real people keep their own name, which no lookup here matches,
     * so the fallback is the stored label.
     */
    actorLabel: {
      'Mini-site': 'מיני-סייט',
      Telephony: 'מרכזייה',
      system: 'המערכת',
      Worki: 'Worki',
      // Every payment provider's webhook, recorded as `billing:<provider>`. The
      // activity screens map the whole prefix here: apps/web/src/lib/actorName.ts.
      billing: 'חברת הסליקה',
    },
    auditAction: {
      'customer_payment.merchant_updated': 'עודכן חיבור ספק התשלומים',
      'customer_payment.created': 'נוצר קישור תשלום ללקוח',
      'customer_payment.paid': 'אומת תשלום מלקוח',
      'customer_payment.declined': 'נדחה תשלום לקוח',
      'customer_payment.cancelled': 'בוטלה בקשת תשלום ללקוח',
      'user.signup': 'נפתח חשבון',
      'user.login': 'כניסה למערכת',
      'user.reviewCodeIssued': 'הונפק קוד לחשבון בדיקת החנות',
      'account.deleteUser': 'המשתמש מחק את החשבון שלו',
      'account.deleteBusiness': 'המשתמש האחרון מחק את העסק ואת כל הנתונים שלו',
      'user.password_reset': 'איפוס סיסמה',
      'profile.update': 'עדכון פרופיל',
      'customer.create': 'נוצר לקוח',
      'customer.update': 'עודכן לקוח',
      'customer.delete': 'נמחק לקוח',
      'inquiry.create': 'נוצרה פנייה',
      'inquiry.status_change': 'שינוי סטטוס פנייה',
      'inquiry.convert': 'פנייה הומרה לליד',
      'inquiry.delete': 'נמחקה פנייה',
      'note.create': 'נוספה הערה',
      'quote.create': 'נוצרה הצעת מחיר',
      'quote.update': 'עודכנה הצעת מחיר',
      'quote.send': 'נשלחה הצעת מחיר',
      'quote.view': 'הלקוח צפה בהצעה',
      'quote.approve': 'הצעת מחיר אושרה',
      'quote.reject': 'הצעת מחיר נדחתה',
      'quote.expire': 'פג תוקף הצעת מחיר',
      'quote.delete': 'נמחקה הצעת מחיר',
      'quote.lock': 'הצעת מחיר ננעלה',
      'quote.unlock': 'שוחררה נעילת הצעת מחיר',
      'signature.create': 'נוצר מסמך להחתמה',
      'signature.update': 'עודכן מסמך להחתמה',
      'signature.upload': 'הועלה קובץ להחתמה',
      'signature.place': 'סומן מקום החתימה במסמך',
      'signature.send': 'נשלח מסמך להחתמה',
      'signature.delivery': 'ערוץ שליחת החתימה תועד',
      'signature.signed': 'המסמך נחתם',
      'signature.cancel': 'בוטלה בקשת החתימה',
      'signature.delete': 'נמחק מסמך להחתמה',
      'signature.declined': 'הנמען בחר שלא לחתום',
      'signature.expire': 'פג תוקף מסמך להחתמה',
      'signature.lock': 'מסמך להחתמה ננעל',
      'signature.unlock': 'שוחררה נעילת מסמך להחתמה',
      'reminder.create': 'נוצרה תזכורת',
      'reminder.update': 'עודכנה תזכורת',
      'reminder.complete': 'תזכורת סומנה כבוצעה',
      'reminder.delete': 'נמחקה תזכורת',
      'reminder.snooze': 'התזכורת נדחתה',
      'agent.create': 'נוצר סוכן טלפוני',
      'agent.update': 'עודכן סוכן טלפוני',
      'agent.delete': 'נמחק סוכן טלפוני',
      'template.create': 'נוצרה תבנית',
      'template.update': 'עודכנה תבנית',
      'template.delete': 'נמחקה תבנית',
      'mail_account.connect': 'חובר חשבון מייל',
      'mail_account.disconnect': 'נותק חשבון מייל',
      'mail_account.reconnect': 'חשבון מייל חובר מחדש',
      'mail_account.sync': 'סונכרנו חשבוניות חדשות',
      'invoice.delete': 'נמחקה חשבונית',
      'invoice.repaired': 'פרטי החשבונית תוקנו לפי מסמך המקור',
      'invoice.upload': 'הועלתה חשבונית',
      'invoice.reset': 'כל החשבוניות נמחקו לסריקה מחדש',
      'invoice.filed': 'חשבוניות הועברו לתיקייה',
      'invoice_folder.created': 'נוצרה תיקיית חשבוניות',
      'invoice_folder.renamed': 'שונה שם תיקיית חשבוניות',
      'invoice_folder.emptied': 'רוקנה תיקיית חשבוניות',
      'invoice_folder.deleted': 'נמחקה תיקיית חשבוניות',
      'invoice_bundle.created': 'חשבוניות שותפו בקובץ אחד',
      'library.add': 'נוסף מסמך לספרייה',
      'library.delete': 'נמחק מסמך מהספרייה',
      'library.edit': 'עודכן מסמך בספרייה',
      'call.inbound': 'תועדה שיחה נכנסת',
      'call.outbound': 'התחיל חיוג יוצא',
      'call.update': 'עודכנה שיחה',
      'call.delete': 'נמחקה שיחה',
      'telephony.number.provisioned': 'הוקצה מספר וירטואלי',
      'user.2fa_enable': 'הופעל אימות דו-שלבי',
      // שלוש הפעולות האלה נכתבו כשניהול המשתמשים היה בידי העסק. הן כבר לא
      // נכתבות, אבל רשומות ישנות נשארות ביומן — הוא append-only.
      'admin.member_invite': 'נשלחה הזמנה לחבר צוות',
      'admin.member_update': 'עודכן חבר צוות',
      'admin.member_delete': 'הוסר חבר צוות',
      'subscription.change': 'עודכן מסלול המנוי',
      // `billing.<event>` for every event a payment provider's adapter reports.
      'billing.checkout_started': 'התחיל תשלום על המנוי',
      'billing.cancelled': 'המנוי בוטל',
      'billing.subscription_activated': 'המנוי הופעל',
      'billing.payment_succeeded': 'התקבל תשלום על המנוי',
      'billing.payment_failed': 'תשלום על המנוי נכשל',
      'billing.subscription_cancelled': 'המנוי בוטל אצל חברת הסליקה',
      'billing.ignored': 'התקבלה הודעה מחברת הסליקה',
      // Both were recorded by the mini-site service from the day it shipped, and
      // both reached the activity feed as the bare key "site.update".
      'site.update': 'עודכן המיני-סייט',
      'site.gallery_delete': 'נמחקה גלריה מהמיני-סייט',
      'site.image_delete': 'נמחקה תמונה מהמיני-סייט',
      'site.review_delete': 'נמחקה חוות דעת מהמיני-סייט',
      'site.review_update': 'עודכנה חוות דעת במיני-סייט',
      'site.gallery_order': 'שונה סדר הגלריות במיני-סייט',
      'site.offer_create': 'נוסף מבצע למיני-סייט',
      'site.offer_update': 'עודכן מבצע במיני-סייט',
      'site.offer_delete': 'נמחק מבצע מהמיני-סייט',
      // מופיע ביומן של העסק עצמו: מי מצוות Worki פתח את הכרטיס שלו ומתי.
      'platform.view_business': 'נצפה על ידי צוות Worki',
      'platform.list_businesses': 'צוות Worki צפה ברשימת העסקים',
      'platform.list_users': 'צוות Worki צפה ברשימת המשתמשים',
      'platform.access': 'צוות Worki שינה את הגישה לחשבון',
      // AUTH-006 — הפעולות האלה מבוצעות בצד של Worki, ולכן הניסוח אומר במפורש
      // מי עשה אותן: זו כל התכלית של רישום שלהן ביומן של העסק.
      'platform.user_update': 'צוות Worki עדכן משתמש',
      'platform.user_remove': 'צוות Worki מחק משתמש',
      'platform.business_remove': 'צוות Worki מחק את העסק',
      // נרשמת גם תחת ה-scope של הפלטפורמה: מי קיבל או איבד גישה לכל העסקים
      // הוא לא רק עניינו של העסק שבו הוא יושב.
      'platform.staff': 'עודכנה הרשאת צוות Worki',
      // שלוש אלה נכתבו כשהעסק החזיק כמה משתמשים. הן כבר לא נכתבות, אבל
      // רשומות ישנות נשארות ביומן — הוא append-only.
      'platform.member_invite': 'צוות Worki הזמין משתמש לעסק',
      'platform.member_update': 'צוות Worki עדכן הרשאות משתמש',
      'platform.member_remove': 'צוות Worki הסיר משתמש מהעסק',
      'platform.landing_create': 'נוסף מקטע לדף הנחיתה',
      'platform.landing_update': 'עודכן מקטע בדף הנחיתה',
      'platform.landing_delete': 'נמחק מקטע מדף הנחיתה',
      'platform.landing_move': 'שונה סדר המקטעים בדף הנחיתה',
      'platform.lead_update': 'צוות Worki עדכן ליד',
      'platform.package': 'צוות Worki עדכן מסלול מנוי',
      'platform.settings': 'צוות Worki עדכן את הגדרות המערכת',
      'platform.trade_create': 'צוות Worki הוסיף תחום עיסוק',
      'platform.trade_update': 'צוות Worki עדכן תחום עיסוק',
    },
  },
  validation: {
    digitalDocument: {"required": "יש למלא שדה חובה זה", "email": "יש להזין כתובת דוא״ל תקינה", "phone": "יש להזין מספר טלפון תקין", "id": "יש להזין 9 ספרות", "companyId": "יש להזין 9 ספרות", "date": "יש להזין תאריך תקין", "number": "יש להזין מספר תקין", "option": "יש לבחור אפשרות מהרשימה", "unknownField": "שדה לא מוכר", "value": "יש להזין ערך תקין (עד 4,000 תווים)", "signature": "יש לחתום במסגרת", "structure": "יש להשלים את תוכן המסמך והגדרות השדות"},
    landing: {
      ctaHref: 'יעד הכפתור חייב להיות נתיב במערכת, למשל /signup',
      locale: 'שפה לא מוכרת',
    },
    signature: {
      title: 'נא להזין שם למסמך',
      body: 'נא להזין את תוכן המסמך',
      signerName: 'נא להזין שם מלא',
      image: 'נא לחתום במסגרת',
      tooLarge: 'החתימה גדולה מדי',
      recipientName: 'נא להזין את שמו המלא של מקבל המסמך',
      fileMissing: 'לא נבחר קובץ',
      fileType: 'אפשר להעלות PDF או Word‏ (DOCX) בלבד',
      fileTooLarge: 'הקובץ גדול מדי',
      fileUnreadable: 'לא הצלחנו לקרוא את הקובץ. אם הוא מוגן בסיסמה, הסירו אותה ונסו שוב.',
      filePages: 'במסמך יותר מדי עמודים',
      anchor: 'מיקום החתימה חורג מגבולות העמוד',
      anchorPage: 'מיקום החתימה מפנה לעמוד שאינו קיים במסמך',
      anchorCount: 'יותר מדי מקומות חתימה במסמך אחד',
      channel: 'בחרו לפחות ערוץ שליחה אחד',
      signer: 'פרטי החותם הנוסף אינם תקינים',
      signerCount: 'אפשר להוסיף עד ארבעה חותמים למסמך אחד',
    },
    invoice: {
      amount: 'הזינו את הסכום שמופיע על החשבונית',
      fileMissing: 'בחרו קובץ או צלמו את החשבונית',
      fileType: 'העלו קובץ PDF או תמונה של החשבונית',
      fileTooLarge: 'הקובץ גדול מדי',
      fileUnreadable: 'לא הצלחנו לקרוא את הקובץ. נסו לצלם שוב.',
      party: 'הזינו את שם הספק או הלקוח',
      number: 'הזינו את מספר החשבונית',
      date: 'הזינו את תאריך החשבונית',
      beforeArchive: 'חשבונית מלפני {{date}} לא תופיע ברשימה. תקנו את התאריך או הסירו אותה',
    },
    scan: {
      empty: 'לא נוספו עמודים לסריקה',
      tooManyPages: 'יותר מדי עמודים בסריקה אחת',
      tooLarge: 'הסריקה כבדה מדי לשליחה בבת אחת. חלקו אותה לשתיים.',
      pageTooLarge: 'אחד העמודים גדול מדי',
      fileType: 'אפשר לצרף תמונות (JPG או PNG) או קובצי PDF',
      unreadable: 'לא הצלחנו לקרוא את אחד העמודים. נסו לצלם שוב.',
    },
    library: {
      empty: 'הקובץ ריק',
      tooLarge: 'הקובץ גדול מדי',
      fileType: 'אפשר להעלות PDF, Word או תמונה',
      // 1.44 — the page editor. The first is a selection the file cannot match; the second is "nothing would be left".
      pages: 'בחירת העמודים אינה תקינה',
      noPages: 'חייב להישאר לפחות עמוד אחד',
    },
    tooLong: 'הערך ארוך מדי',
    tooLarge: 'הערך גדול מדי',
    noSelection: 'לא נבחרו פריטים',
    noChannel: 'יש לבחור לפחות דרך שליחה אחת',
    tooManyItems: 'יותר מדי פריטים',
    email: {
      required: 'נא להזין כתובת אימייל',
      invalid: 'כתובת אימייל לא תקינה',
    },
    otp: { invalid: 'נא להזין קוד בן שש ספרות' },
    name: { required: 'נא להזין שם מלא' },
    businessName: { required: 'נא להזין שם עסק' },
    customerName: { required: 'נא להזין שם לקוח' },
    rating: { invalid: 'דירוג הוא מספר שלם בין 1 ל-5' },
    customer: { required: 'נא לבחור לקוח קיים או להזין לקוח חדש' },
    quoteTitle: { required: 'נא להזין כותרת להצעה' },
    reminderTitle: { required: 'נא להזין כותרת לתזכורת' },
    agentName: { required: 'נא להזין שם לסוכן' },
    trade: { required: 'נא לבחור תחום עיסוק' },
    taxId: { invalid: 'ח.פ/ע.מ הוא 8 או 9 ספרות' },
    terms: { required: 'יש לאשר את תנאי השימוש' },
    templateName: { required: 'נא להזין שם תבנית' },
    templateBody: { required: 'נא להזין תוכן' },
    note: { required: 'נא להזין תוכן' },
    date: { invalid: 'תאריך לא תקין' },
    id: { invalid: 'מזהה לא תקין' },
    token: { invalid: 'הקישור אינו תקין' },
    discount: { invalid: 'ערך הנחה לא תקין' },
    vatRate: { invalid: 'שיעור מע"מ חייב להיות בין 0 ל-100' },
    quoteReminderHours: { invalid: 'ערך חייב להיות בין 1 ל-168 שעות' },
    signatureReminderHours: { invalid: 'ערך חייב להיות בין 1 ל-720 שעות' },
    approvalCode: { invalid: 'יש להזין קוד בן 4 ספרות' },
    rejectionReason: { required: 'נא לבחור סיבה' },
    phone: { invalid: 'נא להזין מספר טלפון תקין' },
    slug: { invalid: 'יש להשתמש באותיות אנגליות קטנות, מספרים ומקפים בלבד', tooShort: 'כתובת ציבורית חייבת להכיל לפחות 3 תווים' },
    folderName: { required: 'נא להזין שם לתיקייה' },
    galleryName: { required: 'נא להזין שם גלריה' },
    foundedYear: { invalid: 'שנת פתיחה לא תקינה' },
    offerName: { required: 'נא להזין שם מבצע' },
    validDays: { invalid: 'תוקף המבצע הוא מספר ימים שלם בין 1 ל-365' },
    quoteValidDays: { invalid: 'תוקף ההצעה הוא 1, 7, 14 או 30 ימים' },
    item: {
      description: 'נא להזין תיאור פריט',
      quantity: 'כמות חייבת להיות גדולה מאפס',
      unitPrice: 'מחיר לא יכול להיות שלילי',
    },
  },
  /**
   * ADM — מסך הניהול של Worki עצמה. הטקסטים כאן נקראים בידי עובד ולא בידי לקוח,
   * ולכן הם מדברים על העסקים בגוף שלישי.
   */
  admin: {
    title: 'ניהול Worki',
    subtitle: 'מה קורה בפלטפורמה, ומי מנהל אותה',
    back: 'חזרה לניהול',
    sections: {
      notifications: 'התראות',
      users: 'ניהול משתמשים',
      approvals: 'ממתינים ומנותקים',
      packages: 'ניהול חבילות',
      staff: 'צוות Worki',
      leads: 'ניהול לידים',
      trades: 'תחומי עיסוק',
      clearing: 'ניהול מסלקה',
      reports: 'דוחות וסטטיסטיקות',
      settings: 'הגדרות מערכת',
      businesses: 'עסקים',
    },
    about: {
      notifications: 'מה דורש טיפול היום',
      users: 'כל מי שיכול להתחבר, בכל העסקים',
      approvals: 'חשבונות שממתינים לפתיחה או שהושהו',
      packages: 'מחירי המסלולים והמכסות שלהם',
      staff: 'מי מצוות Worki רשאי לפתוח את המסכים האלה',
      leads: 'מי ביקש חשבון ומה עלה בגורלו',
      trades: 'רשימת התחומים שטופס ההרשמה מציע',
      clearing: 'ספק הסליקה, החיובים והודעות שהוא שולח',
      reports: 'המספרים של הפלטפורמה לאורך זמן',
      settings: 'מע"מ, אישור הרשמות ותקופת ניסיון',
      businesses: 'כל העסקים, המסלול והשימוש שלהם',
    },
    notifications: {
      empty: 'אין כרגע מה לטפל בו',
      pendingApproval: 'ממתין לאישור',
      pastDue: 'תשלום שנכשל',
      trialEnding: 'תקופת ניסיון מסתיימת',
      subscriptionEnding: 'מנוי מסתיים',
      cancelled: 'מנוי בוטל',
      dormant: 'ללא פעילות',
      newLead: 'ליד חדש',
      waitingDays_one: 'ממתין יום',
      waitingDays: 'ממתין {{count}} ימים',
      endsInDays_one: 'מסתיימת מחר',
      endsInDays: 'מסתיימת בעוד {{count}} ימים',
      silentDays: 'שקט כבר {{count}} ימים',
      neverActive: 'מעולם לא נעשה בו שימוש',
      open: 'פתיחת העסק',
      // ADM-004 — the same five kinds as a line in the bell, where there is no
      // column beside them to say which business they are about.
      bell: {
        pendingApproval: '{{name}} ממתין לאישור',
        pastDue: 'תשלום נכשל אצל {{name}}',
        trialEnding: 'תקופת הניסיון של {{name}} מסתיימת',
        subscriptionEnding: 'המנוי של {{name}} מסתיים בקרוב',
        cancelled: '{{name}} ביטלו את המנוי',
        dormant: '{{name}} ללא פעילות',
        newLead: 'ליד חדש: {{name}}',
      },
      mine: 'ההתראות שלי',
    },
    users: {
      searchPlaceholder: 'חיפוש לפי שם, אימייל או עסק',
      allTypes: 'כל המשתמשים',
      onlyStaff: 'צוות Worki',
      onlyCustomers: 'לקוחות',
      allStates: 'הכל',
      onlyActive: 'פעילים',
      onlyInactive: 'מושהים',
      staff: 'צוות Worki',
      staffHint: 'גישה לניהול הפלטפורמה — לכל העסקים, לא רק לעסק שלו. כל פעולה נרשמת ביומן של העסק שנגעו בו.',
      rootStaffHint: 'ההרשאה הזו מוגדרת בקובץ הסביבה של השרת, ולכן אי אפשר לבטל אותה מכאן.',
      never: 'מעולם',
      empty: 'לא נמצאו משתמשים',
      edit: 'עריכת משתמש',
      active: 'רשאי להתחבר',
      remove: 'מחיקת המשתמש',
      removeConfirm: 'למחוק את {{name}}? הפעולה אינה הפיכה, והרשומות שהוא יצר יאבדו את השיוך אליו. השהיה שומרת על השיוך.',
      // המשתמש האחרון בעסק הוא העסק: המחיקה לוקחת אתו הכול, ולכן היא אומרת
      // את זה לפני ולא אחרי.
      removeBusiness: 'מחיקת המשתמש והעסק',
      removeBusinessConfirm:
        'זה המשתמש היחיד בעסק {{business}}, ולכן מחיקת {{name}} מוחקת את העסק עצמו — הלקוחות, ההצעות, החשבוניות, המסמכים והקבצים. אין שחזור. להשהיית העסק יש פעולה נפרדת, והיא הפיכה.',
      saved: 'המשתמש עודכן',
      removed: 'המשתמש נמחק',
      removedBusiness: 'המשתמש והעסק נמחקו',
    },
    approvals: {
      pending: 'ממתינים לאישור',
      suspended: 'מנותקים',
      pendingEmpty: 'אין חשבונות שממתינים לאישור',
      suspendedEmpty: 'אין חשבונות מנותקים',
      ended: 'החבילה הסתיימה',
      endedHint: 'מנוי שבוטל או תקופת ניסיון שנגמרה. החשבון פתוח, אך לא ניתן לעבוד בו עד חידוש החבילה.',
      endedEmpty: 'אין חשבונות שהחבילה שלהם הסתיימה',
      approve: 'אישור',
      suspend: 'ניתוק',
      restore: 'חיבור מחדש',
      approved: 'החשבון נפתח',
      wasSuspended: 'החשבון נותק',
      restored: 'החשבון חובר מחדש',
      suspendConfirm: 'לנתק את {{name}}? כל מי שמחובר יוצא מיד מהמערכת, ושום נתון לא נמחק.',
      joined: 'נרשם',
      hint: 'אישור הרשמות נדרש רק כשהמתג בהגדרות המערכת דלוק. אחרת כל הרשמה נפתחת מיד.',
    },
    packages: {
      price: 'מחיר חודשי',
      priceHint: 'בשקלים, לפני מע"מ',
      limits: 'מכסות',
      connectedMailAccounts: 'תיבות דואר',
      galleries: 'גלריות',
      quotesPerMonth: 'הצעות מחיר בחודש',
      voiceActionsPerMonth: 'הצעות בהכתבה ל-AI בחודש',
      unlimited: 'ללא הגבלה',
      unlimitedShort: '∞',
      saved: 'המסלול עודכן',
      hint: 'שינוי כאן חל על כל העסקים במסלול, כולל אלה שכבר משלמים.',
    },
    staff: {
      root: 'צוות קבוע',
      rootHint: 'הכתובות שמוגדרות בקובץ הסביבה של השרת. אי אפשר להוסיף או להסיר אותן מהדפדפן — זו הרשימה שממנה משחזרים גישה אם כל השאר ננעל.',
      rootEmpty: 'לא הוגדרו כתובות בקובץ הסביבה',
      granted: 'גישה שניתנה מהמערכת',
      grantedHint: 'משתמשים שקיבלו גישה לניהול הפלטפורמה מתוך המערכת עצמה. אפשר לבטל אותה בכל רגע.',
      grantedEmpty: 'אף אחד לא קיבל גישה מהמערכת',
      manage: 'הענקה וביטול נעשים בכרטיס המשתמש, במסך ניהול משתמשים',
    },
    leads: {
      searchPlaceholder: 'חיפוש לפי עסק, שם, אימייל או טלפון',
      allStatuses: 'כל הסטטוסים',
      status: {
        new: 'חדש',
        contacted: 'נוצר קשר',
        converted: 'הפך ללקוח',
        lost: 'לא סגר',
      },
      empty: 'עדיין אין לידים',
      note: 'הערה',
      notePlaceholder: 'מה נאמר בשיחה…',
      saved: 'הליד עודכן',
      trade: 'תחום',
      hint: 'כל מי שהתחיל הרשמה נרשם כאן, גם אם לא סיים אותה.',
    },
    trades: {
      name: 'שם התחום',
      // 'סדר' לבד לא אמר במה מדובר: המספר קובע את מיקום התחום ברשימה שבטופס
      // ההרשמה, שהמסך הזה בכלל לא מציג.
      position: 'מיקום ברשימה',
      positionHint: 'מספר קטן יותר מופיע גבוה יותר בטופס ההרשמה. הרשימה מדלגת בעשרות, כדי שאפשר יהיה לשבץ תחום בין שניים קיימים.',
      active: 'מוצע בהרשמה',
      inactive: 'הוסר מההרשמה',
      add: 'תחום חדש',
      empty: 'עדיין אין תחומים',
      saved: 'התחום נשמר',
      hint: 'תחום שמכובה יורד מטופס ההרשמה, והעסקים שכבר בחרו בו ממשיכים לומר במה הם עוסקים.',
    },
    reports: {
      months: 'שנים עשר החודשים האחרונים',
      signups: 'הרשמות',
      quotes: 'הצעות מחיר',
      invoices: 'חשבוניות',
      planMix: 'תמהיל מסלולים',
      businesses: 'עסקים',
      revenue: 'הכנסה חודשית',
      mrr: 'הכנסה חודשית חוזרת',
      approved: 'הצעות שאושרו',
      inquiries: 'פניות',
      payingOnly: 'רק חשבונות משלמים נספרים בהכנסה. ניסיון אינו הכנסה.',
    },
    clearing: {
      provider: 'ספק סליקה',
      providerHint: 'הספק שמחייב את המנויים. שינוי נעשה בקובץ ההגדרות של השרת, לא כאן.',
      live: 'פעיל',
      off: 'סליקה ידנית',
      webhookUrl: 'כתובת לקבלת הודעות מהספק',
      paying: 'מנויים משלמים',
      pastDue: 'בפיגור תשלום',
      unattributed: 'ללא שיוך לעסק',
      events: 'הודעות אחרונות מהספק',
      eventsHint: 'כל הודעה שהתקבלה, גם אם לא שינתה מנוי. שקט מוחלט לאורך זמן מעיד בדרך כלל על תקלה בחיבור.',
      noEvents: 'לא התקבלו הודעות מהספק',
      notApplied: 'לא יושמה',
      unknownAccount: 'עסק לא מזוהה',
    },
    settings: {
      vatRate: 'שיעור מע"מ',
      vatRateHint: 'חל על כל הצעת מחיר שתיכתב מעכשיו. הצעות שכבר נכתבו שומרות את השיעור שלהן.',
      requireApproval: 'הרשמה חדשה ממתינה לאישור',
      requireApprovalHint: 'כשהמתג דלוק, חשבון חדש נוצר אך בעליו אינו יכול להתחבר עד שמישהו יאשר אותו.',
      trialDays: 'ימי ניסיון',
      subscriptionAlertDays: 'התראה לפני סיום מנוי (ימים)',
      subscriptionAlertDaysHint:
        'כמה ימים מראש יופיעו בהתראות מנוי או תקופת ניסיון שעומדים להסתיים. ביטולי מנוי מוצגים לאותו מספר ימים לאחור.',
      supportEmail: 'אימייל תמיכה',
      saved: 'ההגדרות נשמרו',
    },
  },
  voice: {
    record: 'הקלטה קולית',
    recordHint: 'ספר מה להכניס להצעה: לקוח, טלפון ומייל, עבודה, כתובת, מחיר',
    editHint: 'ספר מה לשנות בהצעה: שורות ומחירים, פרטי הלקוח, הנחה, הערות',
    dictateHint: 'דבר — הטקסט ייכנס לשדה',
    start: 'התחל הקלטה',
    stop: 'סיים ושלח',
    send: 'שלח',
    cancel: 'ביטול',
    recording: 'מקליט… {{seconds}} שניות',
    stage: {
      queued: 'ממתין בתור — מקום {{position}}',
      transcribing: 'מתמלל את ההקלטה…',
      understanding: 'מבין מה ביקשת…',
      ready: 'הטיוטה מוכנה',
      failed: 'לא הצלחנו',
      cancelled: 'בוטל',
    },
    heard: 'מה ששמענו',
    recordAgain: 'הקלט שוב',
    useAsNotes: 'השתמש כהערות',
    useTranscript: 'השתמש בתמלול',
    estimated: 'משוער',
    priceMissing: 'חסר מחיר',
    checkAmount: 'בדוק סכום',
    pickCustomer: 'למי ההצעה?',
    newCustomer: 'לקוח חדש: {{name}}',
    editsApplied: 'השינויים הוכנסו לעורך — עדיין לא נשמרו',
    /* 04.10 — the quote has no address field, so the work address is a line of the notes. */
    workAddressLine: 'כתובת ביצוע: {{address}}',
    editsSkipped: 'לא הוכנסו {{count}} שינויים כי השורות השתנו',
    micDenied: 'אין הרשאה למיקרופון',
    // The live screen (Task 12): what the orb is doing, in words, under it.
    listening: 'מקשיב…',
    paused: 'מושהה',
    pause: 'השהה',
    resume: 'המשך',
    // Between "finish" and the server naming the job — the upload itself.
    sending: 'שולח…',
  },
  errors: {
    historyOriginalUnavailable: 'לשליחה ישנה זו לא נשמר שיוך לקישור. אי אפשר למחוק אותה ולבטל רק את הקישור שלה באופן בטוח.',
    voice: {
      notInPlan: 'הקלטה קולית לא כלולה בחבילה שלך',
      quotaReached: 'נגמרו ההצעות בהכתבה ל-AI לחודש הזה',
      busy: 'המערכת עמוסה כרגע, נסה שוב בעוד כמה דקות',
      alreadyRunning: 'כבר יש הקלטה בעיבוד',
      tooLong: 'ההקלטה ארוכה מ-2 דקות',
      badFormat: 'קובץ השמע אינו נתמך',
      empty: 'לא נשמע דיבור בהקלטה',
      sttFailed: 'התמלול נכשל',
      notUnderstood: 'לא הצלחנו להבין את הבקשה',
      timeout: 'העיבוד לקח יותר מדי זמן',
      interrupted: 'העיבוד נקטע, הקלט שוב',
      unavailable: 'שירות הקול לא זמין כרגע',
      quoteNotDraft: 'אפשר לערוך בקול רק טיוטה',
    },
    signatureLocked: 'המסמך נעול',
    quoteLocked: 'ההצעה נעולה',
    // HIST 2.8 — a lapsed link is not re-opened by sending it again.
    quoteExpired: 'תוקף ההצעה פג, ולכן לא ניתן לשלוח אותה שוב',
    signatureExpired: 'תוקף המסמך פג, ולכן לא ניתן לשלוח אותו שוב',

    accountPending: 'החשבון נוצר וממתין לאישור של Worki. נעדכן אתכם במייל ברגע שהוא נפתח.',
    accountSuspended: 'הגישה לחשבון הושהתה. פנו אלינו כדי לפתוח אותו מחדש.',
    unknown: 'אירעה שגיאה לא צפויה',
    network: 'אין חיבור לשרת',
    validation: 'יש שדות שדורשים תיקון',
    unauthorized: 'נדרשת התחברות מחדש',
    forbidden: 'אין לכם הרשאה לפעולה זו',
    notFound: 'הפריט המבוקש לא נמצא',
    conflict: 'הפעולה מתנגשת עם המצב הנוכחי',
    mailFailed: 'שליחת האימייל נכשלה. בדקו את כתובת הנמען ונסו שוב.',
    signatureSent: 'המסמך כבר נשלח לחתימה ולא ניתן לערוך אותו. בטלו את הבקשה כדי לשנות.',
    signatureSigned: 'המסמך כבר נחתם',
    signatureCancelled: 'בקשת החתימה בוטלה',
    signatureDeclined: 'הנמען כבר סירב לחתום על המסמך',
    signatureUnsigned: 'המסמך עדיין לא נחתם',
    signatureEmpty: 'אין מה לחתום עליו — צרפו קובץ למסמך לפני השליחה',
    signatureNoFile: 'צרפו קובץ למסמך לפני סימון מקום החתימה',
    docxConverterMissing:
      'המרת קובצי Word לא זמינה בשרת הזה. שמרו את המסמך כ‑PDF והעלו אותו — התוצאה זהה.',
    emailTaken: 'כתובת האימייל כבר רשומה במערכת',
    rateLimited: 'יותר מדי ניסיונות. נסו שוב בעוד רגע.',
    quoteNotSendable: 'לא ניתן לשלוח הצעה במצב זה',
    quoteAlreadyDecided: 'ההצעה כבר אושרה או נדחתה',
    quoteApprovedLocked: 'הצעה מאושרת נשמרת כרשומה של ההסכם ואינה ניתנת למחיקה',
    quoteLinkExpired: 'תוקף הקישור פג',
    // Not a refusal: the erase did happen. A customer named on a quote or an
    // invoice has to stay attached to those records, so only the personal
    // details could go.
    customerHasDocuments: 'ללקוח משויכות הצעות מחיר או חשבוניות שחייבות להישמר, ולכן פרטי הקשר שלו נמחקו והרשומה עצמה נשארה.',
    invoiceBundleEmpty: 'אף אחת מהחשבוניות שנבחרו אינה קובץ שניתן לצרף',
    folderNameTaken: 'כבר קיימת תיקייה בשם הזה',
    // 1.45 — the same refusal for "המסמכים שלי", under its own key so that either
    // screen can change how it says it.
    libraryFolderNameTaken: 'כבר קיימת תיקייה בשם הזה',
    // 1.44 — the page editor: a screen that opened an older version of the file, and a file with no pages to cut.
    libraryChanged: 'המסמך עודכן במכשיר אחר. סגרו את העריכה ופתחו אותה מחדש.',
    libraryNotEditable: 'אי אפשר לערוך את העמודים של הקובץ הזה',
    // 1.59 — "שיתוף" of several documents as one PDF: a file with no pages to put in it (Word, say), and a selection too heavy to make into one.
    libraryNotMergeable: 'אפשר לשתף יחד רק קובצי PDF ותמונות (JPG או PNG). קובץ Word או קובץ אחר — שתפו בנפרד.',
    libraryMergeTooLarge: 'המסמכים שנבחרו גדולים מדי לשיתוף כקובץ אחד. בחרו פחות מסמכים, או שתפו אותם בנפרד.',
    // Section 9 — several files saved as one document. The row of the file is marked, so the words need not name it.
    libraryCombineUnreadable: 'לא הצלחנו לקרוא את הקובץ המסומן. אם הוא מוגן בסיסמה, הסירו אותה ונסו שוב.',
    libraryCombineFileType: 'אפשר לאחד למסמך אחד רק קובצי PDF, Word ותמונות JPG או PNG',
    fileTooLarge: 'הקובץ גדול מדי',
    fileType: 'סוג קובץ לא נתמך',
    slugTaken: 'הכתובת הציבורית הזו כבר בשימוש',
    // The ceilings come from the plan, so the message names the plan and not a
    // number that stops being true the moment the business upgrades.
    galleryLimit: 'הגעתם למספר הגלריות המרבי במסלול.',
    imageLimit: 'ניתן להעלות עד 10 תמונות בכל גלריה',
    quoteLimit: 'הגעתם למכסת הצעות המחיר החודשית של המסלול.',
    mailAccountLimit: 'הגעתם למספר תיבות הדוא"ל המרבי במסלול.',
    telephonyProvider: 'ספק הטלפוניה לא הצליח להתחיל את השיחה',
    virtualNumberTaken: 'המספר הזה כבר משויך למשתמש אחר',
    virtualNumberUnknown: 'המספר הזה אינו מספר של העסק',
    taxIdTaken: 'מספר ח.פ/ע.מ הזה כבר רשום ב-Worki',
    phoneTaken: 'מספר הנייד הזה כבר רשום ב-Worki',
    tradeUnknown: 'תחום העיסוק שנבחר אינו קיים',
    tradeTaken: 'כבר קיים תחום עיסוק בשם הזה',
    googleDisabled: 'כניסה עם Google אינה מופעלת בשרת הזה',
    googleFailed: 'הכניסה עם Google לא הושלמה',
    googleCancelled: 'הכניסה עם Google בוטלה',
    googleUnverified: 'כתובת הדוא"ל בחשבון Google אינה מאומתת',
    googleExpired: 'תוקף ההרשמה עם Google פג. נא להתחיל מחדש.',
    accountDisabled: 'החשבון הזה מושבת',
    // TEL-001. שלוש דחיות שונות, כי הפעולה שמתבקשת אחריהן שונה: להגדיר ספק,
    // לבחור מדינה אחרת (או להזין מספר ידנית), או פשוט לא לעשות כלום.
    telephonyNotConfigured: 'הקצאת מספר אוטומטית אינה זמינה בשרת הזה. הזינו מספר קיים בשדה שלמעלה.',
    telephonyNoNumbers: 'לספק הטלפוניה אין כרגע מספר פנוי להקצאה. נסו שוב מאוחר יותר או הזינו מספר קיים.',
    virtualNumberExists: 'כבר משויך לכם מספר וירטואלי. מחקו אותו לפני הקצאת מספר חדש.',
    upstream: 'שירות חיצוני לא זמין כרגע. נסו שוב.',
    billingProvider: 'ספק התשלומים החזיר שגיאה.',
    billingNotConfigured: 'התשלומים אינם מוגדרים במערכת.',
    billingWebhookUnverified: 'לא ניתן לאמת את הודעת ספק התשלומים.',
    // Worded so it cannot be read as "cancelled": the subscription is exactly
    // as it was, and someone has to finish the cancellation by hand.
    billingCancelUnsupported: 'ביטול המנוי לא הושלם מול ספק התשלומים ולא בוצע שום שינוי במנוי. פנו אלינו כדי שנשלים את הביטול.',
    invoiceSyncDisabled: 'סנכרון תיבת הדוא"ל אינו פעיל בשרת זה.',
    subscriptionInactive: 'המנוי אינו פעיל. יש לחדש כדי להמשיך לערוך.',
    // ADM-002 — שלוש הדחיות של ניהול המשתמשים. כל אחת אומרת גם מה כן אפשר
    // לעשות במקום, כי אחרת המסך רק אומר "לא".
    lastUser: 'זה המשתמש האחרון בעסק. השהיה או מחיקה שלו תשאיר את העסק בלי דרך להיכנס — לניתוק החשבון עצמו יש פעולה נפרדת, והיא הפיכה.',
    staffSelf: 'אי אפשר לשנות את המשתמש שאיתו מחוברים כרגע. עובד אחר בצוות יכול לעשות את זה.',
    staffRoot: 'ההרשאה הזו מוגדרת בקובץ הסביבה של השרת, ולכן אי אפשר לבטל אותה מכאן.',
    // מסך הקריסה: תקלה בצד הדפדפן, לא סירוב של השרת. לכן אין כאן קוד שגיאה
    // לתרגם — רק מה שאפשר לעשות עכשיו.
    crashTitle: 'משהו השתבש במסך הזה',
    crashBody: 'הנתונים שלכם לא נפגעו. אפשר לנסות לטעון מחדש, או לחזור למסך הראשי.',
    crashReload: 'טעינה מחדש',
    crashHome: 'למסך הראשי',
    // Section 3 — a quick-scanned invoice the list already holds (same party,
    // same number). Also the label on each such row of the summary screen.
    invoiceScanDuplicate: 'כבר קיימת ברשימה',
  },
  mail: {
    loginCodeSubject: 'קוד הכניסה שלך ל-Worki',
    loginCodeBody: 'שלום {{name}},\n\nקוד הכניסה שלך ל-Worki הוא: {{code}}\n\nהקוד תקף ל-10 דקות ולשימוש חד-פעמי.',
    signupCodeSubject: 'אישור פתיחת חשבון ב-Worki',
    signupCodeBody:
      'שלום {{name}},\n\nקוד האימות לפתיחת חשבון עבור {{business}} ב-Worki הוא: {{code}}\n\nהקוד תקף ל-10 דקות. החשבון נפתח רק לאחר הזנת הקוד.\n\nאם לא ביקשתם זאת, אפשר להתעלם מהודעה זו — לא נפתח שום חשבון.',
    // 1.34 — what the sign-up screen promises a waiting account ("we will email
    // you the moment it opens"). Sent once, when Worki approves it.
    accountApprovedSubject: 'החשבון שלכם ב-Worki אושר',
    accountApprovedBody:
      'שלום {{name}},\n\nהחשבון שלכם ב-Worki אושר ואפשר להיכנס אליו.\n\nלכניסה:\n{{link}}\n\nהכניסה היא עם Google או עם קוד שנשלח לאימייל שאיתו נרשמתם.',
    quoteSubject: 'הצעת מחיר #{{number}} מאת {{business}}',
    // 2.4 — a send carries no file (only an approved quote has one, and it goes
    // out as a copy), so this says the quote was sent and leaves opening it to
    // `quoteLink` below.
    quoteBody: 'שלום {{name}},\n\nנשלחה אליכם הצעת מחיר מס\' {{number}} מאת {{business}}.',
    // Sent on its own line after the body — a business owner who writes a
    // personal note replaces the body, and without this the mail would go out
    // with no way to open the quote.
    quoteLink: 'לצפייה ולאישור ההצעה:\n{{link}}\n\nהקישור בתוקף ל-{{days}} ימים.',
    // One day is "one day", not "1 days": the server takes this form for a count of 1.
    quoteLink_one: 'לצפייה ולאישור ההצעה:\n{{link}}\n\nהקישור בתוקף ליום אחד.',
    approvedSubjectOwner: 'הצעה #{{number}} אושרה',
    approvedSubjectCustomer: 'אישור הצעת מחיר #{{number}}',
    approvedBody: 'הצעת מחיר מס\' {{number}} אושרה בתאריך {{date}}.\nמצורף עותק חתום.',
    signatureSubject: 'מסמך לחתימה מאת {{business}}',
    signatureBody:
      'שלום,\n\n{{business}} מבקשים את חתימתכם על המסמך "{{title}}".\n\nלקריאה ולחתימה:\n{{link}}',
    signedSubject: 'המסמך "{{title}}" נחתם',
    signedBody: 'המסמך "{{title}}" נחתם על ידי {{name}}.\nמצורף עותק חתום.',
    declinedSubject: 'המסמך "{{title}}" נדחה',
    declinedBody: '{{name}} קרא את המסמך "{{title}}" ובחר שלא לחתום עליו.\nהסיבה: {{reason}}',
    declinedNoReason: 'לא נמסרה סיבה',
    rejectedSubject: 'הצעה #{{number}} נדחתה',
    rejectedBody: 'הצעת מחיר מס\' {{number}} נדחתה. סיבה: {{reason}}',
    invoicesSubject: '{{count}} חשבוניות מ-{{business}}',
    invoicesSubject_one: 'חשבונית אחת מ-{{business}}',
    // Used when the sender named the batch. Their name leads, because it is what
    // the accountant will look for when they come back to find this message.
    invoicesSubjectTitled: '{{title}} — {{count}} חשבוניות מ-{{business}}',
    invoicesSubjectTitled_one: '{{title}} — חשבונית אחת מ-{{business}}',
    // The link is in the body for mail too: the attachment is the document, and
    // the link is what someone forwards on to whoever actually files it.
    invoicesBody:
      'שלום,\n\nמצורף קובץ אחד ובו {{count}} חשבוניות של {{business}}.\n\nלצפייה גם בקישור:\n{{link}}\n\nהקישור בתוקף ל-14 ימים.',
    invoicesBody_one:
      'שלום,\n\nמצורפת חשבונית של {{business}}.\n\nלצפייה גם בקישור:\n{{link}}\n\nהקישור בתוקף ל-14 ימים.',
    // WhatsApp carries no attachment, so the same send has to be described
    // differently there: the link is the document, not a copy of it.
    invoicesLinkBody:
      'שלום,\n\nמצורף קישור לקובץ אחד ובו {{count}} חשבוניות של {{business}}:\n{{link}}\n\nהקישור בתוקף ל-14 ימים.',
    invoicesLinkBody_one:
      'שלום,\n\nמצורף קישור לחשבונית של {{business}}:\n{{link}}\n\nהקישור בתוקף ל-14 ימים.',
    // 1.9 — under the body of every message that carries the invoices, mail and
    // WhatsApp, one line per currency: what they come to, and the VAT worked out
    // the way the summary card works it out.
    invoicesTotal: '{{count}} חשבוניות · סך החשבוניות: {{total}} · מע״מ להחזר ({{rate}}%): {{vat}}',
    reminderSubject: 'תזכורת: {{title}}',
    reminderBody: 'שלום {{name}},\n\nהגיע מועד התזכורת "{{title}}".',
  },
  /* Text the server writes into the database on its own, with no user typing it. */
  auto: {
    quoteFollowUpTitle: 'מעקב אחרי הצעת מחיר #{{number}}',
    quoteFollowUpNotes: 'הלקוח עדיין לא אישר ולא דחה את ההצעה.',
    signatureFollowUpTitle: 'מעקב אחרי המסמך "{{title}}"',
    signatureViewedNotes: 'הנמען פתח את המסמך ועדיין לא חתם עליו.',
    signatureUnopenedNotes: 'המסמך עדיין לא נפתח — ייתכן שהקישור כלל לא הגיע.',
    // נושא הפנייה נשמר כטקסט והמסך מציג אותו כמות שהוא, ולכן הוא נכתב בשפת
    // העסק. מי שביצע את הפעולה, לעומת זאת, מתורגם בזמן ההצגה דרך
    // enum.actorLabel — הוא הולך אחרי מי שקורא, לא אחרי מי שכתב.
    telephonySubject: 'שיחה נכנסת',
  },
  /* SIG — documents sent out to be signed. Its own screen, because what a
     contractor needs signed is usually not priced work. */
  /*
   * HIST — the send history, which lists quotes and documents for signature
   * together. Its own block rather than more keys under `quotes`, because the
   * screen is no longer only about quotes.
   */
  history: {
    folderPreviewTitle: 'תיקייה שנשלחה',
    folderFiles: 'קבצים שנשלחו ({{count}})',
    folderManifestUnavailable: 'רשימת הקבצים המקורית לא נשמרה.',
    folderOriginalUnavailable: 'קובץ ה־PDF המקורי שנשלח אינו זמין.',
    folderDeleteConfirm: 'למחוק {{count}} רשומות מההיסטוריה? הקישור הציבורי שנשלח יבוטל, כולל בשליחות אחרות מאותה שליחה. קובצי המקור יישמרו.',
    resultNumber: 'תוצאה {{number}}',
    channelUnknown: 'לא תועד',
    openForPrint: 'פתיחת PDF להדפסה',
    channel: { email: 'אימייל', whatsapp: 'וואטסאפ', both: 'אימייל ווואטסאפ', copy: 'קישור שהועתק' },
    delivery: { delivered: 'נשלח', handoff: 'השלמת השליחה בוואטסאפ' },
    sendFormat: 'פורמט שליחה',
    formatLink: 'קישור',
    formatPdf: 'PDF',
    formatBoth: 'קישור ו־PDF',
    partialDelivery: 'חלק מהמשלוחים נכשלו. אפשר לנסות שוב בערוצים שנכשלו.',

    lock: 'נעילת מסמך',
    unlock: 'שחרור נעילה',
    locked: 'המסמך נעול לצפיית הלקוח',
    sendCount: 'נשלח {{count}} פעמים',
    lockSaved: 'נעילת המסמך עודכנה',
    sendToAnotherSigner: 'שליחה לחותם נוסף',
    /* HIST 2.10 — an approved quote or a signed document, sent to the customer
       again. A copy of what was agreed and not a new request, and worded to stay
       true on WhatsApp, where nothing is attached and the link is the copy. */
    sendCopy: 'שליחת עותק',
    copySent: 'העותק נשלח',
    /* 1.17 — the popup a copy (or any send of a quote) opens: who it is for, and
       which of their two ways of being reached it goes to, either or both. */
    sendRecipient: 'שם הלקוח/הנמען',
    sendChannels: 'טלפון / דוא"ל',
    sendByPhone: 'טלפון (וואטסאפ)',
    sendByEmail: 'דוא"ל',
    sendPickChannel: 'יש לבחור טלפון או דוא"ל',
    copyEntry: 'עותק',
    copyQuoteSubject: 'עותק של הצעת מחיר #{{number}} מאת {{business}}',
    copyQuoteBody: 'שלום {{name}},\n\nהנה עותק של הצעת מחיר מס\' {{number}} מאת {{business}}, כפי שאושרה.',
    copyQuoteLink: 'לצפייה בהצעה:\n{{link}}',
    copyDocumentSubject: 'עותק חתום של "{{title}}" מאת {{business}}',
    copyDocumentBody: 'שלום,\n\nהנה עותק חתום של המסמך "{{title}}" מאת {{business}}.\n\nלצפייה ולהורדה:\n{{link}}',

    title: 'היסטוריית שליחות',
    new: 'חדש',
    newQuote: 'הצעת מחיר',
    newDocument: 'מסמך לחתימה',
    kindLabel: 'סוג מסמך',
    kind: { 'invoice-folder': 'תיקיות חשבוניות', 'library-folder': 'תיקיות מסמכים', all: 'הכל', quote: 'הצעות מחיר', signature: 'מסמכי חתימה' },
    tabHistory: 'היסטוריית שליחות',
    tabLibrary: 'המסמכים שלי',
    /* The list holds quotes and documents for signature both, so a batch is
       counted rather than named after one of the two kinds in it. */
    deleteConfirm_one: 'למחוק את הפריט שנבחר? הפעולה אינה הפיכה.',
    deleteConfirm: 'למחוק {{count}} פריטים שנבחרו? הפעולה אינה הפיכה.',
  },

  /* LIB — the owner's own documents, kept for whenever they are next needed. */
  library: {
    saveAndPrint: 'שמירה והדפסה',
    resultRange: 'תוצאות {{from}}–{{to}} מתוך {{total}}',
    shareFolder: 'שיתוף תיקייה',
    selfSignTitle: 'חתימה עצמית על מסמך',
    selfSignSave: 'שמירת PDF חתום',
    selfSignHint: 'ציירו או ייבאו חתימה או חותמת, ואז לחצו על המסמך למיקום החתימה. שמרו את ה-PDF החתום במסמכים שלי להורדה ושיתוף.',
    moveSomeRefused: '{{count}} מסמכים לא הועברו. הם נשארו מסומנים כדי שתוכלו לבדוק ולנסות שוב.',
    title: 'המסמכים שלי',
    upload: 'העלאת מסמכים',
    createDigital: 'צור מסמך דיגיטלי',
    searchPlaceholder: 'חיפוש במסמכים…',
    added_one: 'מסמך אחד נוסף',
    added: '{{count}} מסמכים נוספו',
    sendToSign: 'שליחה לחתימה',
    renameTitle: 'שינוי שם המסמך',
    titleLabel: 'שם המסמך',
    deleteTitle: 'מחיקת מסמך',
    deleteManyTitle_one: 'מחיקת מסמך אחד',
    deleteManyTitle: 'מחיקת {{count}} מסמכים',
    deleteSomeRefused_one: 'מסמך אחד לא נמחק. יש לרענן את הרשימה ולנסות שוב.',
    deleteSomeRefused: '{{count}} מסמכים לא נמחקו. יש לרענן את הרשימה ולנסות שוב.',
    deleteBody: 'המסמך יימחק מהספרייה. מסמכים שכבר נשלחו לחתימה לא יושפעו.',
    emptyTitle: 'עדיין אין מסמכים',
    emptyBody: 'העלו מסמך או סרקו אותו, והוא יחכה כאן מוכן לשליחה או לחתימה.',
    // 1.45 — the folder menu beside the search box. "כל המסמכים" takes the choice
    // away, so the list is every document again, filed or not.
    allDocuments: 'כל המסמכים',
    folders: 'תיקיות',
    // The menu before a single folder has been made: it says so in the list
    // rather than leaving the control looking broken.
    noFoldersYet: 'עדיין אין תיקיות',
    newFolder: 'תיקייה חדשה',
    folderName: 'שם התיקייה',
    renameFolder: 'שינוי שם התיקייה',
    deleteFolder: 'מחיקת תיקייה',
    // The bin beside a folder. It names the folder and says the documents stay:
    // the server takes them out of the folder and deletes none of them.
    deleteFolderNamed_zero: 'למחוק את התיקייה "{{name}}"? אין בה מסמכים.',
    deleteFolderNamed_one: 'למחוק את התיקייה "{{name}}"? המסמך שבה לא יימחק — הוא יישאר בין המסמכים שלי, בלי תיקייה.',
    deleteFolderNamed: 'למחוק את התיקייה "{{name}}"? {{count}} המסמכים שבה לא יימחקו — הם יישארו בין המסמכים שלי, בלי תיקייה.',
    // The row menu's "move", the list it opens, and what is said once it is done.
    moveToFolder: 'העברה לתיקייה',
    noFolder: 'ללא תיקייה',
    moveNoFolders: 'עדיין אין תיקיות. אפשר ליצור אחת מרשימת התיקיות.',
    movedTo: 'המסמך הועבר לתיקייה "{{name}}"',
    movedOut: 'המסמך הוצא מהתיקייה',
    // 1.44 — the pencil: the document's pages as a grid, where one is taken out
    // with its X and files are added at the end. "הוספת קבצים" is Nitzan's word.
    editTitle: 'עריכת מסמך',
    addFiles: 'הוספת קבצים',
    editHint: 'אפשר להסיר עמודים ב-X, או להוסיף קבצים — העמודים שלהם יתווספו בסוף המסמך.',
    editPagesFailed: 'לא ניתן להציג את עמודי המסמך. אפשר רק לשנות את שמו.',
    // 1.59 — several documents shared at once go out as one PDF, and this is
    // the name it carries in the share sheet ("מסמכים.pdf").
    mergedName: 'מסמכים',
    // Section 9 — several files picked together are always one document. The
    // short screen before it is saved: its name, and the files in order, moved
    // with arrows. "שם המסמך" is `titleLabel`.
    combineTitle: 'שמירה כמסמך אחד',
    combineHint: 'כל הקבצים יישמרו כמסמך PDF אחד, לפי הסדר הזה. קובץ Word יומר ל־PDF.',
    combineOrder: 'סדר הקבצים',
    combining: 'מאחד את הקבצים למסמך אחד…',
    // The X on a row of that screen. It takes the file out of this batch only.
    combineRemove: 'הסרת קובץ {{index}}',
  },

  // Section 3 (Nitzan, 05.10) — the invoices' quick scan: every file an invoice of
  // its own, read, checked on one screen, and filed a row each. It replaced
  // "הוספת חשבונית" (section 6). Plurals are `_one` and the plain key, so two
  // falls back to the plain key rather than to the key's name.
  invoiceScan: {
    duplicateBlocked: 'החשבונית כבר שמורה. יש להסיר אותה מהסריקה כדי להמשיך.',
    duplicateLocation: 'חשבונית קיימת {{number}} · {{folder}}',
    duplicateChanged: 'החשבונית כבר קיימת. יש להתחיל סריקה חדשה כדי לראות היכן היא שמורה.',
    choose: 'בחרו חשבונית אחת או כמה',
    chooseHint: 'כל קובץ וכל צילום נשמרים כחשבונית נפרדת. PDF של כמה עמודים הוא חשבונית אחת.',
    camera: 'מצלמה',
    cameraHint: 'צילום החשבוניות אחת אחרי השנייה',
    file: 'קובץ',
    fileHint: 'PDF או תמונה, אחד או כמה',
    // The review's button in the camera, where the pages go on to be read.
    next: 'המשך',
    addFiles: 'הוספת קבצים',
    preparing: 'מכינים קובץ {{current}} מתוך {{total}}…',
    reading_one: 'קוראים את החשבונית…',
    reading: 'קוראים {{count}} קבצים…',
    // A file the server could not open, on its line in the list. It can be taken out.
    fileRefused: 'את הקובץ הזה אי אפשר לקרוא. הסירו אותו ונסו שוב',
    removeFile: 'הסרת {{name}}',
    blur: {
      live: 'מטושטש — החזיקו יציב',
      ask: 'התמונה מטושטשת. לצלם שוב?',
      retake: 'צילום חוזר',
      keep: 'השארה',
      mark: 'התמונה מטושטשת',
    },
    count_one: 'חשבונית אחת',
    count: '{{count}} חשבוניות',
    total: 'סה״כ',
    totalExpense: 'הוצאות',
    totalIncome: 'הכנסות',
    direction: 'הוצאה או הכנסה',
    directionInfo: 'הוצאה — חשבונית שהעסק קיבל מספק. הכנסה — חשבונית שהעסק הוציא ללקוח שלו.\nהכנסה נספרת בנפרד: היא לא נכנסת לסך ההוצאות ולא למע״מ להחזר, ובמקום שם הספק מופיע שם הלקוח.',
    expense: 'הוצאה',
    income: 'הכנסה',
    supplier: 'ספק',
    customer: 'לקוח',
    number: 'מספר חשבונית',
    amount: 'סכום',
    currency: 'מטבע',
    date: 'תאריך',
    untitled: 'חשבונית {{index}}',
    edit: 'עריכת {{name}}',
    // A row the server put together from several photographs: one invoice of
    // that many pages. "הפרדה" makes a row of each again.
    joined: 'צורף · {{count}} עמודים',
    pages_one: 'עמוד אחד',
    pages: '{{count}} עמודים',
    split: 'הפרדה',
    joinPrevious: 'צירוף לחשבונית הקודמת',
    // What a row lacks before it can be saved, named: "חסר: סכום, תאריך".
    missing: 'חסר: {{fields}}',
    duplicate: 'כבר קיימת ברשימה',
    reuseDuplicate: 'החשבונית כבר נשמרה. הרשומה הקיימת תשויך לתיקייה שנבחרה.',
    preview: 'תצוגה מקדימה של {{name}}',
    page: 'עמוד {{index}}',
    pagesCut: 'מוצגים {{shown}} עמודים ראשונים מתוך {{total}}',
    remove: 'הסרת {{name}}',
    folder: 'תיקייה',
    folderHint: 'לא חובה. כל חשבונית נשמרת לחוד, והתיקייה מקבצת אותן לשליחה.',
    folderNone: 'בלי תיקייה',
    folderNew: 'תיקייה חדשה…',
    folderName: 'שם התיקייה',
    saveSend: 'שמירה ושליחה',
    saving_one: 'שומרים את החשבונית…',
    saving: 'שומרים {{count}} חשבוניות…',
    blocked_one: 'חשבונית אחת צריכה תיקון לפני השמירה',
    blocked: '{{count}} חשבוניות צריכות תיקון לפני השמירה',
    saved_one: 'החשבונית נשמרה',
    saved: '{{count}} חשבוניות נשמרו',
  },

  scan: {
    title: 'סריקה מהירה',
    hint: 'צלמו עמוד אחר עמוד — כל עמוד מיושר ומנוקה מיד. סיימו כשתסיימו.',
    addPhoto: 'צילום עמוד',
    addFile: 'צירוף קובץ',
    empty: 'עדיין לא נוספו עמודים',
    pageCount_one: 'עמוד אחד',
    pageCount: '{{count}} עמודים',
    removePage: 'הסרת עמוד {{index}}',
    movePageUp: 'הזזת עמוד {{index}} אחורה',
    movePageDown: 'הזזת עמוד {{index}} קדימה',
    create: 'יצירת PDF',
    done: 'סיום',
    addMore: 'צילום נוסף',
    // 1.58 — the same dialog on a desktop, where there is no camera: a dropzone in
    // the camera's place, and "הוספת קבצים" where the review said "צילום נוסף".
    // There (section 9) files added together are one document, and a PDF or a
    // Word file on its own is filed as it is, which is what the two lines under
    // the zone say. The ones ending in "Pages" are for a dialog with nowhere to
    // file a document, where every file is a page.
    dropTitle: 'גררו לכאן קבצים, או לחצו כדי לבחור',
    dropTypes: 'PDF, Word, JPG או PNG',
    dropHint: 'קבצים שמעלים יחד נשמרים כמסמך PDF אחד. קובץ PDF או Word יחיד נשמר כמו שהוא.',
    dropTypesPages: 'PDF, JPG או PNG',
    dropHintPages: 'אפשר להוסיף כמה קבצים יחד — כולם יהפכו לקובץ PDF אחד, עמוד אחרי עמוד.',
    addMoreFiles: 'הוספת קבצים',
    fileName: 'סריקה',
    name: 'שם המסמך',
    nameHint: 'לא חובה — בלי שם המסמך ייקרא "סריקה"',
    /* SCAN-004 — the viewfinder. Every line of it is read while the phone is
       being held up at a document, so each says one thing and stops. */
    camera: {
      starting: 'מפעיל מצלמה…',
      waiting: 'המצלמה פעילה, אבל התמונה עדיין לא מוצגת.',
      denied: 'אין הרשאה למצלמה. אפשר לצרף קבצים במקום.',
      unavailable: 'אין מצלמה זמינה במכשיר. אפשר לצרף קבצים במקום.',
      searching: 'מחפש מסמך…',
      found: 'החזיקו יציב',
      holding: 'מצלם…',
      shutter: 'צילום עמוד',
      auto: 'אוטומטי',
      /* Several rear cameras is the normal case on a phone, and the one a
         browser opens by default is often the ultra-wide. */
      lens: 'מצלמה',
      numbered: 'מצלמה {{index}}',
      /* Only on a phone whose camera admits to having a lamp — which today
         means Android. The button is absent everywhere else. */
      lamp: 'פנס',
    },
    /* SCAN-006 — fixing one page. */
    editTitle: 'תיקון עמוד',
    editPage: 'תיקון עמוד {{index}}',
    cropHint: 'גררו את הפינות עד שהמסגרת תתאים לגבולות המסמך.',
    /* The two ways of looking at one page: the finished scan, and the photo it
       was cut out of. */
    viewPage: 'המסמך הסרוק',
    viewCrop: 'חיתוך',
    previewHint: 'כך ייראה העמוד בקובץ.',
    preparing: 'מכין תצוגה…',
    cropBroken: 'הפינות לא יוצרות מסמך. תקנו את החיתוך.',
    rotateLeft: 'סיבוב שמאלה',
    rotateRight: 'סיבוב ימינה',
    wholePhoto: 'כל התמונה',
    /* Named by where they are on the picture, not on the screen: the picture
       does not flip when the interface does. */
    corner: {
      0: 'פינה עליונה־שמאלית',
      1: 'פינה עליונה־ימנית',
      2: 'פינה תחתונה־ימנית',
      3: 'פינה תחתונה־שמאלית',
    },
    /* The look of the pages — one choice for all of them. */
    filter: {
      label: 'מראה',
      colour: 'צבע',
      mono: 'שחור־לבן',
      original: 'מקורי',
      info: 'צבע — מנקה את הרקע והצללים ומחדד את הדף, ומשאיר את הצבעים. זו הבחירה המומלצת.\nשחור־לבן — מסמך חד של כתב שחור על רקע לבן.\nמקורי — התמונה כפי שצולמה, רק ישרה וחתוכה לפי הפינות, בלי ניקוי.',
    },
    applying_one: 'מעבד עמוד…',
    applying: 'מעבד {{count}} עמודים…',
    reviewHint: 'הקישו על עמוד כדי לתקן את החיתוך או לסובב אותו.',
    /* Closing the dialog does not throw a scan away; only "ביטול" does, and
       only creating the file finishes it. */
    restored_one: 'חזרנו לסריקה שלא סיימתם — עמוד אחד ממתין.',
    restored: 'חזרנו לסריקה שלא סיימתם — {{count}} עמודים ממתינים.',
    ready_one: 'נוצר קובץ בן עמוד אחד',
    ready: 'נוצר קובץ בן {{count}} עמודים',
    // 1.46 — how many files the scan holds, said under the viewfinder and above the
    // review. And how far the PDF has got while it is made: the page that is being
    // made ready, of all of them, and then the file itself — for an invoice that is
    // where the pages are read, which is why it is not a page count.
    filesAdded_one: 'קובץ אחד נוסף',
    filesAdded: '{{count}} קבצים נוספו',
    making: 'מכין עמוד {{current}}/{{total}}…',
    merging: 'יוצר את הקובץ…',
  },
  signing: {
    entryContactRequired: 'נדרש קישור אישי מהשולח',
    signatureConfirm: 'אישור',
    entryContinue: 'המשך',
    sendFormat: 'פורמט השליחה',
    sendFormatLink: 'קישור',
    sendFormatBoth: 'קישור ו-PDF',
    inkColor: 'צבע העט',
    inkBlack: 'שחור',
    inkBlue: 'כחול',
    inkWidth: 'עובי הקו',
    inkTools: 'כלי ציור',
    inkCancel: 'ביטול ציור',
    inkThicker: 'הגדלת עובי הקו',
    inkThinner: 'הקטנת עובי הקו',
    inkColors: {0:'שחור',1:'כחול',2:'ירוק',3:'אדום',4:'סגול',5:'כתום',6:'ורוד'},
    placeTodayDate: 'התאריך של היום',
    inkPen: 'עט',
    inkLine: 'קו ישר',
    inkEraser: 'מחק',
    inkSelect: 'בחירה ומיקום',
    recipientChipsTitle: 'נמענים לחתימה',
    recipientChipsHint: 'הוסיפו את הלקוחות שיקבלו את מסמך החתימה',
    recipientChipsEmpty: 'לחצו על הפלוס להוספת לקוח',
    recipientEdit: 'עריכת {{name}}',
    recipientRemove: 'הסרת {{name}}',
    recipientAddTitle: 'הוסף לקוח',
    recipientEditTitle: 'עריכת לקוח',
    personalLinkRequired: 'יש לבקש מהשולח קישור חתימה אישי עבורכם.',
    entryIdentityHint: 'בחרו את שמכם ואשרו את הדוא״ל או הטלפון שהשולח הזין. ללא פרטי קשר יש לבקש מהשולח קישור חתימה אישי.',
    entryIdentity: 'מי החותם?',
    entryContact: 'דוא״ל או טלפון',
    identityMismatch: 'הפרטים אינם תואמים לחותם שנבחר.',
    senderDetection: {
      enabled: 'זהה אוטומטית מיקומי חתימת השולח', scanning: 'מחפש כיתובי חתימת שולח במסמך…',
      found: 'נוספו {{count}} מיקומי חתימת שולח. אפשר לבדוק ולשנות את המיקום לפני השליחה.',
      none: 'לא נמצאו כיתובי חתימת שולח שניתן לזהות. אפשר לסמן מיקומים ידנית; מסמך סרוק דורש סימון ידני.',
      failed: 'לא ניתן לזהות מיקומים בקובץ הזה. אפשר להמשיך בסימון ידני.',
    },
    revisionChanged: 'המסמך השתנה מאז שפתחתם אותו. טענו את הגרסה העדכנית לפני שמירה.',
    senderStampUpload: 'הוספת חותמת',
    senderStampPicture: 'חותמת השולח',
    senderStampRemove: 'הסרת החותמת',
    senderSignatureCombinedPreview: 'תצוגת החתימה והחותמת',
    title: 'מסמכים לחתימה',
    subtitle: 'מסמכים שנשלחים ללקוח לחתימה דיגיטלית — טופס בטיחות, תנאים, אישור כניסה לאתר',
    searchPlaceholder: 'חיפוש לפי שם מסמך או נמען…',
    new: 'מסמך חדש לחתימה',
    edit: 'עריכת מסמך',
    document: 'מסמך',
    documentName: 'שם המסמך',
    documentNameHint: 'איך המסמך ייקרא ברשימה ובמייל שיישלח. ברירת המחדל היא שם הקובץ.',
    // The name box is also the way into the shelf, so it says so where the
    // sender is already looking rather than in a second control below it.
    documentNameSearchHint: 'אפשר לכתוב שם חדש, או לחפש מסמך שכבר העליתם — החץ פותח את הרשימה',
    pickFiledDocument: 'בחירה מתוך המסמכים שלי',
    /* 1.23 — several of them at once: a box on every row of that list, and at its
       foot a line saying so, which becomes this button once any is ticked. */
    pickFiledManyHint: 'אפשר לסמן כמה מסמכים ולהוסיף אותם יחד',
    pickFiledAdd_one: 'הוספת מסמך אחד',
    pickFiledAdd: 'הוספת {{count}} מסמכים',
    /* §7 (05.10) — on a desktop the list opens from a labelled button inside the
       name box; the X beside it empties a typed name; and the line under the
       box when the list could not be fetched. */
    myDocuments: 'המסמכים שלי',
    documentNameClear: 'ניקוי השם',
    libraryLoadFailed: 'לא הצלחנו לטעון את המסמכים שלי.',
    /* Read-only now. Nothing writes a typed-out document any more; the ones
       written before SIG-003 still open, and this labels their text. */
    body: 'תוכן המסמך',
    /* SIG-003 — the recipient, typed rather than picked. */
    recipient: 'מי חותם',
    recipientName: 'שם מלא',
    recipientPhone: 'טלפון',
    recipientEmail: 'דוא"ל',
    recipientHint: 'אם המספר או הכתובת כבר מוכרים למערכת, המסמך ישויך ללקוח הקיים אוטומטית.',
    linkedCustomer: 'שויך ללקוח קיים: {{name}}',
    statusLabel: 'סטטוס',
    /* SIG-003 — the file and where the signature goes on it. */
    fileHint: 'PDF, Word‏ (DOCX) או תמונה. אפשר לבחור כמה קבצים — הם יאוחדו למסמך אחד לחתימה.',
    fileAdd: 'הוספת קובץ',
    /* 1.22 — beside "add a file", under the document's name. */
    digitalCreate: 'יצירת מסמך דיגיטלי',
    filesMerged: '{{count}} קבצים אוחדו למסמך אחד',
    fileReplace: 'החלפת הקובץ',
    filePages_one: 'עמוד אחד',
    filePages: '{{count}} עמודים',
    fileUploading: 'מעלה וממיר…',
    fileReplaceWarning: 'החלפת הקובץ תמחק את מקומות החתימה שסומנו.',
    /* 1.29, 1.30 — taking a file, or the pick of one, back out. */
    fileCancel: 'ביטול הבחירה',
    fileRemove: 'הסרת הקובץ',
    fileRemovedBoxesCleared: 'הקובץ הוסר. מקומות החתימה נמחקו, כי העמודים השתנו',
    place: 'בחר את המיקום הרצוי להוספת חתימה או הוספת טקסט',
    placeDragHint: 'אפשר לגרור למקום מדויק',
    placeCount_one: 'אזור חיתום אחד',
    placeCount: '{{count}} אזורי חיתום',
    placeRemove: 'הסרת המקום הזה',
    placeClear: 'ניקוי כל המקומות',
    /* 1.47 — a saved signature picked under the pages, with no place marked for the sender's signature to take it. */
    placeSavedTap: 'לחצו על המסמך כדי למקם את החתימה.',
    placeSavedLimit: 'המסמך הגיע למספר האזורים המרבי. הסירו אזור לפני מיקום החתימה.',
    placeSavedNoBox: 'כדי להוסיף חתימה שמורה, הוסיפו קודם בעמוד אזור "חתימת השולח".',
    placeBigger: 'הגדלה',
    placeSmaller: 'הקטנה',
    placeText: 'טקסט חופשי',
    /* 1.33 — the box's width, read out between bigger and smaller. */
    placeSizeLabel: 'רוחב המקום: {{value}}% מרוחב העמוד',
    /* 1.1 — a text field the sender fills in before sending. */
    placeSenderText: 'הקלידו כאן את הטקסט',
    senderTextMissing: 'יש מקום שסימנתם "מילוי בעצמך" ועדיין ריק. מלאו אותו או הסירו אותו, ואז שלחו.',
    /* 1.1, redone — what goes in a place, as each box says it. */
    placeRoleSignerSignature: 'חתימת הלקוח',
    placeRoleSenderSignature: 'חתימת השולח',
    placeRoleSignerText: 'טקסט שהנמען ממלא',
    /* 1.1, a third time — the box goes down first, and its bar says what goes in it. */
    placeSignatureMenu: 'חתימה במקום הזה',
    placeTextMenu: 'טקסט במקום הזה',
    placeSignSelf: 'חתימת השולח',
    placeSignByRecipient: 'חתימת הלקוח',
    placeFillSelf: 'מילוי בעצמך',
    placeFillByRecipient: 'מילוי על ידי הנמען',
    senderSignatureTitle: 'החתימה שלי',
    senderSignatureHint: 'חתמו בתוך המסגרת או בחרו חתימה שמורה',
    senderSignatureSignHere: 'חתום כאן',
    senderSignatureSave: 'שמירת החתימה',
    senderSignatureRedo: 'חתימה מחדש',
    senderSignatureMissing: 'יש מקום שסימנתם "חתימת השולח" ועדיין לא חתמתם בו. חתמו בו או הסירו אותו, ואז שלחו.',
    senderSignatureUpload: 'העלאת חתימה',
    senderSignatureDraw: 'ציור במקום התמונה',
    senderSignaturePicture: 'החתימה מהתמונה',
    senderSignatureNoInk: 'לא מצאנו חתימה בתמונה. צלמו מקרוב חתימה בעט כהה על דף לבן.',
    senderSignatureUnreadable: 'לא הצלחנו לקרוא את התמונה. נסו קובץ PNG או JPEG אחר.',
    senderSignatureRemember: 'שמירת החתימה לשימוש חוזר',
    senderSignatureSavedList: 'חתימות שמורות',
    senderSignatureAdd: 'הוספה',
    senderSignatureNoneKept: 'עדיין אין חתימות שמורות',
    senderSignatureListFull: 'אפשר לשמור עד {{max}} חתימות. הסירו אחת כדי להוסיף.',
    senderSignatureUseKept: 'שימוש בחתימה השמורה',
    senderSignatureForget: 'הסרה מהמכשיר',
    senderSignatureForgetFailed: 'לא הצלחנו להסיר את החתימה מהמכשיר.',
    senderSignatureKeepFailed: 'לא הצלחנו לשמור את החתימה במכשיר.',
    senderSignatureNotKept: 'החתימה נוספה למסמך, אבל המכשיר לא אפשר לשמור אותה לפעם הבאה.',
    /* SIG-003 — more than one person on the same page. */
    placeForNextSigner: 'מקום חתימה לחותם הבא',
    placeDuplicate: 'שכפול לאותו חותם',
    placeCopy: 'שכפול שדה',
    stampColorMode: 'צבעי החותמת',
    stampOriginal: 'צבעי מקור',
    stampBlackWhite: 'שחור לבן',
    placeSigner: 'הבוקס שייך לחותם {{number}} — לחיצה מעבירה לחותם הבא',
    signerNumber: 'חותם {{number}}',
    signerAdd: 'הוספת חותם נוסף',
    signerRemove: 'הסרת החותם',
    signerNameMissing: 'נא להזין שם לחותם {{number}}',
    signerLinks: 'הקישורים לחתימה',
    signerWaiting: 'טרם חתם',
    placeSaving: 'שומר…',
    placeSaved: 'מקומות החתימה נשמרו',
    preview: 'תצוגה מקדימה',
    previewSigned: 'העותק החתום',
    signer: 'חתם',
    signedAt: 'מועד החתימה',
    notViewed: 'טרם נצפה',
    viewedTimes_one: 'נצפה פעם אחת',
    viewedTimes: 'נצפה {{count}} פעמים',
    send: 'שליחה לחתימה',
    resend: 'שליחה חוזרת',
    saveDraft: 'שמירה כטיוטה',
    draftKept: 'המסמך נשמר כטיוטה',
    numberBadge: 'מסמך חיתום מס׳ {{number}}',
    sentAtLabel: 'נשלח {{when}}',
    signedBy: 'נחתם על ידי {{name}} · {{when}}',
    declinedAtLabel: 'נדחה {{when}}',
    /* The one date at the top of a sent document is its latest event: made,
       sent (`sentAtLabel`), signed, or declined (`declinedAtLabel`). */
    detailCreated: 'נוצר {{when}}',
    detailSigned: 'נחתם {{when}}',
    declineReason: 'סיבת הדחייה: {{reason}}',
    sendVia: 'שליחה דרך',
    channelEmail: 'אימייל',
    channelWhatsapp: 'וואטסאפ',
    sendTo: 'שליחה לכתובת',
    sendToHint: 'ריק — נשלח לכתובת שעל המסמך. בלי כתובת כלל, הקישור עדיין נוצר.',
    sendToPhone: 'שליחה למספר',
    sendToPhoneHint: 'ריק — נשלח למספר שעל המסמך. בלי מספר כלל, הקישור עדיין נוצר.',
    whatsappReady: 'וואטסאפ נפתח עם ההודעה — נשאר ללחוץ שליחה',
    sent: 'המסמך נשלח לחתימה',
    linkReady: 'הקישור מוכן להעברה',
    deliveredTo: 'נשלח אל {{to}}',
    converting: 'מכין את המסמך…',
    composeEmpty: 'בחרו קובץ והדפים יופיעו כאן לסימון',
    sendByEmail: 'שליחה במייל',
    sendByWhatsapp: 'שליחה בוואטסאפ',
    /* SIG-004 — how it goes out: one channel or both, and on what clock. */
    sendChannels: 'ערוצי שליחה',
    sendOptions: 'הגדרות שליחה',
    pickAChannel: 'בחרו לפחות ערוץ שליחה אחד',
    needEmail: 'נא להזין כתובת דוא"ל לשליחה במייל',
    needPhone: 'נא להזין מספר טלפון לשליחה בוואטסאפ',
    validDays: 'תוקף הקישור',
    validDaysOption_one: 'יום אחד',
    validDaysOption: '{{count}} ימים',
    validDaysDefault: 'ברירת מחדל ({{count}} ימים)',
    followUp: 'תזכורת אם לא נחתם',
    hoursShort: '{{count}} שע׳',
    followUpDefault: 'לפי הגדרת העסק',
    followUpEvery_one: 'תזכורת אם לא נחתם תוך שעה',
    followUpEvery: 'תזכורת אם לא נחתם תוך {{count}} שעות',
    leaveTitle: 'לצאת בלי לשלוח?',
    leaveBody: 'עוד לא נשמר כלום — הקובץ, המקומות שסומנו עליו והפרטים שהוקלדו כאן ילכו לאיבוד.',
    link: 'קישור לחתימה',
    cancel: 'ביטול בקשת החתימה',
    download: 'הורדת המסמך החתום',
    deleteTitle: 'מחיקת המסמך',
    deleteBody: 'המסמך יוסר מההיסטוריה וקישור הצפייה של הלקוח ייחסם.',
    emptyTitle: 'אין עדיין מסמכים לחתימה',
    emptyBody: 'כאן נשמרים מסמכים שנשלחו ללקוחות לחתימה דיגיטלית, והעותק החתום חוזר לכאן.',
    /* At the top of the screen opened from "send to another signer". */
    duplicateNotice: 'שליחה חדשה של אותו מסמך לחותם נוסף. יש להזין את פרטי החותם; ייווצרו מספר מסמך וקישור חתימה נפרדים.',
    /* The button on a sent document that opens that screen. */
    duplicateForAnotherSigner: 'שכפול לחותם נוסף',
    /* The digital document: its builder, its preview, and what the compose
       screen shows only for one. */
    digital: {
      quickDefaults: 'הוספת שדות לקוח', bold: 'הדגשת פסקה', underline: 'קו תחתון לפסקה',
      alignLeft: 'יישור לשמאל', alignCenter: 'מרכוז', alignRight: 'יישור לימין', numberedList: 'מספור פסקאות', divider: 'קו מפריד',
      importTerms: 'ייבוא תנאי שירות', importFromLibrary: 'ייבוא מהמסמכים שלי',
      importTermsHint: 'קובץ טקסט או PDF עם טקסט ניתן לחיפוש. אפשר לערוך את הטקסט לאחר הייבוא.',
      importTermsFailed: 'לא ניתן לייבא את הטקסט מהקובץ', importNoText: 'הקובץ אינו מכיל טקסט שניתן לחלץ. אפשר להדביק את התנאים ידנית.',
      importTooLarge: 'הקובץ או הטקסט גדולים מדי לייבוא', terms: 'תנאי שירות', agreementText: 'אני מאשר/ת את תנאי השירות', yes: 'כן', no: 'לא',
      backToFile: 'העלאה או סריקה',
      contactHint: 'פרטי יצירת הקשר למשלוח הקישור. הלקוח ימלא את שדות המסמך בעצמו.',
      previewBeforeSend: 'תצוגה מקדימה לפני שליחה',
      title: 'כותבים את המסמך',
      intro: 'כתבו כרגיל. הקלידו @ במקום שבו הלקוח צריך למלא פרט.',
      addField: 'שדה למילוי',
      undo: 'ביטול פעולה',
      redo: 'ביצוע מחדש',
      inlineHint: 'שדות המילוי משתלבים בתוך המשפט',
      editorLabel: 'תוכן המסמך',
      /* The same sentence twice: the editor's own placeholder, and the line under it while it is empty. */
      placeholder: 'לדוגמה: מסמך זה נחתם בין @שם לקוח, ת״ז @תז',
      example: 'לדוגמה: מסמך זה נחתם בין @שם לקוח, ת״ז @תז',
      /* The tooltip of a field inside the text. */
      editField: 'לחצו לעריכת השדה',
      fieldSettings: 'הגדרות שדה המילוי',
      /* The list that opens on @. */
      chooseField: 'בחירת שדה למילוי',
      backToEditing: 'חזרה לעריכת המסמך',
      notSaved: 'המסמך עדיין לא נשמר ולא נשלח.',
      previewSize: 'גודל התצוגה',
      desktop: 'מחשב',
      mobile: 'מובייל',
      finalNumber: 'המספר והתאריך הסופיים נקבעים בשליחה.',
      customerSigns: 'כאן תופיע חתימת הלקוח',
      /* The builder's own name, its preview button and its row of tools. */
      document: 'מסמך דיגיטלי',
      customerPreview: 'תצוגת הלקוח',
      fields: 'שדות למילוי',
      heading: 'כותרת',
      paragraph: 'פסקה',
      /* Under the editor, after a number each: "2 שדות למילוי · 1 שדות חובה". */
      fieldCount: 'שדות למילוי',
      requiredCount: 'שדות חובה',
      /* The settings of the field picked in the text. */
      fieldLabel: 'שם השדה שמוצג ללקוח',
      fieldType: 'סוג התשובה',
      requiredBeforeSigning: 'חובה למלא לפני החתימה',
      fieldHint: 'דוגמה או הנחיה בשדה',
      choices: 'אפשרויות לבחירה',
      choicesHint: 'אפשרות אחת בכל שורה, עד 20 אפשרויות.',
      /* The two choices a list starts with. They are written into the document, not only shown. */
      optionOne: 'אפשרות ראשונה',
      optionTwo: 'אפשרות שנייה',
      remove: 'הסרה',
      previewHint: 'אפשר לנסות למלא את השדות כאן. התשובות לדוגמה אינן נשלחות.',
      emptyPreview: 'הוסיפו תוכן למסמך כדי לראות את תצוגת הלקוח.',
      /* The compose screen: the name field's placeholder, and the card that says who it goes to. */
      documentNameExample: 'לדוגמה: אישור ביצוע עבודה',
      deliveryStep: 'בוחרים למי לשלוח',
      /* The label a new field starts with, by the choice that added it. */
      presets: {
        city: 'יישוב', agreement: 'אישור תנאי שירות', checkbox: 'תיבת סימון', yesNo: 'כן או לא',
        name: 'שם מלא',
        phone: 'טלפון',
        id: 'תעודת זהות',
        companyId: 'ח.פ. / מספר חברה',
        email: 'אימייל',
        address: 'כתובת',
        date: 'תאריך',
        signature: 'חתימה',
        custom: 'שדה מותאם',
      },
      /* The kinds of answer a field can be switched to. */
      types: {
        text: 'טקסט קצר',
        textarea: 'טקסט ארוך',
        phone: 'מספר טלפון',
        email: 'כתובת אימייל',
        id: 'תעודת זהות',
        companyId: 'מספר חברה',
        date: 'תאריך',
        number: 'מספר',
        checkbox: 'תיבת אישור',
        select: 'בחירה מרשימה',
        signature: 'חתימה ביד',
      },
    },
    /* SIG-005, 1.50 — what the signer is told while the picture they picked is read. */
    assets: {
      preparing: 'מכין את התמונה…',
      rejected: 'יש לבחור תמונת חתימה או חותמת מסוג PNG או JPG, עד 5MB.',
      tooDetailed: 'לא הצלחנו להקטין את התמונה הזו. כדאי לצלם רק את החתימה או החותמת, על רקע בהיר.',
    },
    status: {
      draft: 'טיוטה',
      sent: 'נשלח/בהמתנה',
      viewed: 'נצפה',
      signed: 'נחתם',
      declined: 'נדחה',
      expired: 'פג תוקף',
      cancelled: 'בוטל',
    },
  },
  /* The customer's side of the same document. */
  publicSign: {
    creatorSessionNotice: 'זוהה שאתם מחוברים לחשבון שיצר את בקשת החתימה. ניתן להמשיך ולחתום באמצעות הקישור הזה.',
    signersTitle: 'החותמים',
    waitingTitle: 'חתימתך נשמרה',
    waitingBody: 'המסמך ממתין לחותמים נוספים. ברגע שכולם יחתמו תתקבל הודעה על כך. המשך יום טוב.',
    revisionChanged: 'המסמך עודכן. טענו וקראו את הגרסה העדכנית לפני חתימה.',
    reloadLatest: 'טעינת המסמך העדכני',
    notFound: 'המסמך לא נמצא',
    signed: 'המסמך נחתם',
    signedBody: 'תודה, {{name}}. עותק חתום נשלח לעסק ואפשר לשמור אותו גם כאן.',
    download: 'הורדת עותק חתום',
    cancelled: 'בקשת החתימה בוטלה',
    expired: 'פג תוקף הקישור',
    closedBody: 'פנו לעסק ששלח את המסמך כדי לקבל קישור חדש.',
    /* SIG-004 — the recipient's other answer. */
    decline: 'לא מעוניין לחתום',
    declineReason: 'סיבה (לא חובה)',
    declineReasonHint: 'העסק יראה את מה שתכתבו כאן. אפשר גם לשלוח בלי סיבה.',
    declineConfirm: 'שליחת סירוב',
    declined: 'המסמך נדחה',
    declinedBody: 'הודענו לעסק שבחרתם שלא לחתום. אם זו הייתה טעות, פנו אליהם לקבלת קישור חדש.',
    signerName: 'שם מלא',
    drawHere: 'חתימה',
    drawHint: 'חתמו באצבע או בעכבר בתוך המסגרת.',
    clear: 'ניקוי',
    /* 1.6 — beside clear on the pad: takes back the last stroke only. */
    undo: 'חזור',
    /* 1.50 — a picture of a stamp or a signature: the icon in the pad, the button that puts it in the boxes, its thumbnail, and the X that takes it back. */
    uploadMark: 'העלאה או צילום של חותמת או חתימה',
    saveMark: 'שמור',
    pickedMark: 'התמונה שנבחרה',
    removeMark: 'הסרת התמונה',
    submit: 'אישור וחתימה',
    /* SIG-003 — the uploaded file, read before signing. */
    documentHint: 'קראו את המסמך במלואו לפני החתימה. החתימה תוטבע במקומות המסומנים.',
    signHere: 'כאן החתימה',
    typeHere: 'כאן ממלאים',
    documentTextHint: 'במסמך יש שדות למילוי. מלאו אותם על גבי המסמך, ואז חתמו למטה.',
    signedDocumentHint: 'זה העותק החתום, עם החתימה במקום שסומן.',
    /* SIG-003 — a document more than one person signs. */
    yourBoxes: 'המקומות המסומנים במספר {{number}} הם שלכם. השאר שייכים לחותמים האחרים.',
    waitingOnOthers: 'המסמך ממתין עוד לחתימת: {{names}}',
  },
  /**
   * MKT-001 — the marketing page.
   *
   * The copy lives here with every other string in the product, which is what
   * makes the page exist in both languages and read correctly in both
   * directions. A section can still be rewritten from the page itself: that
   * edit is stored beside the section as an override of this text, and
   * clearing it brings this text back.
   *
   * No prices here. The plan cards are rendered from the live price list and
   * labelled with the billing screen's own words, so the page cannot advertise
   * a plan the back office has already changed.
   */
  landing: {
    signIn: 'כניסה',
    signInTitle: 'כניסה לורקי',
    signInHint: 'בלי סיסמה. נשלח קוד לכתובת, או שנכנסים עם Google.',
    noAccount: 'עדיין אין לכם חשבון?',
    signedInTitle: 'שלום {{name}}',
    signedInCta: 'כניסה למערכת',
    plansTrial: '{{days}} ימי התנסות מלאים, בלי כרטיס אשראי',
    editor: {
      badge: 'עריכה',
      hint: 'העריכה מחליפה את הטקסט המקורי בשפה הנוכחית בלבד.',
      edit: 'עריכת מקטע',
      add: 'הוספת מקטע',
      newSection: 'מקטע חדש',
      remove: 'מחיקת מקטע',
      removeConfirm: 'למחוק את המקטע?',
      hide: 'הסתרה מהמבקרים',
      show: 'הצגה למבקרים',
      hidden: 'מוסתר',
      reset: 'החזרת הטקסט המקורי',
      resetConfirm: 'למחוק את העריכה ולהחזיר את הטקסט המקורי?',
      kind: 'סוג המקטע',
      eyebrow: 'כותרת עליונה',
      heading: 'כותרת',
      body: 'טקסט',
      bullets: 'שורות',
      bulletsHint: 'שורה אחת בכל שורה.',
      ctaLabel: 'טקסט הכפתור',
      ctaHref: 'יעד הכפתור',
      ctaHrefHint: 'נתיב בתוך המערכת, למשל /signup',
      empty: 'אין עדיין מקטעים בדף.',
    },
    kind: {
      hero: 'פתיח',
      feature: 'יכולת',
      plans: 'חבילות',
      cta: 'קריאה לפעולה',
    },
    sections: {
      hero: {
        heading: 'המערכת היחידה שבאמת עוזרת לך לסגור יותר עסקאות!',
        body: 'כל מה שבעל עסק צריך כדי להפוך פנייה לעסקה — במקום אחד.',
        // "(בקרוב)" is not decoration: the hero draws a trailing parenthetical
        // as a badge, and the phone agent is not finished being designed. A
        // promise on the way in is the one place it must not be overstated.
        bullets: ['הצעות מחיר חכמות', 'תיק עבודות', 'מעקב לקוחות', 'ניהול לידים', 'סוכנ/ת טלפוני/ת AI (בקרוב)'],
        ctaLabel: 'התחילו עכשיו',
      },
      quotes: {
        heading: 'שולחים הצעה ומפסיקים לנחש',
        body: 'ממשק פשוט ומהיר לשליחת הצעות מחיר מקצועיות תוך כמה רגעים, שמוצגות ללקוח בצורה נוחה ומזמינה.',
      },
      tracking: {
        eyebrow: 'כשאתם יודעים בדיוק את סטטוס ההצעה',
        heading: 'הכול מולכם בזמן אמת',
        bullets: ['האם הלקוח פתח את ההצעה?', 'כמה זמן הוא צפה בה?', 'התראה על אישור או על דחייה'],
      },
      portfolio: {
        eyebrow: 'פתאום הצעת המחיר היא הרבה יותר ממסמך גנרי',
        heading: 'תיק העבודות שלכם מוצג בתוך ההצעה',
        body: 'בצורה מרשימה ומקצועית — כי לפני שהלקוח קונה את המחיר, הוא חייב לדעת מי אתם.',
      },
      invoices: {
        eyebrow: 'פחות התעסקות, יותר שליטה',
        heading: 'החשבוניות נמשכות מתיבות הדוא"ל שלכם',
        body: 'חברו את תיבות הדוא"ל ומשכו חשבוניות ישירות למערכת. פחות חיפושים, פחות ניירת — הכול כאן ועכשיו.',
      },
      ai: {
        eyebrow: 'ולגולת הכותרת — כשאתם לא עונים (בקרוב)',
        heading: 'מזכירת ה-AI שלכם עונה בעברית ברורה ואיכותית',
        body: 'גם כשאתם עסוקים, בפגישה, בחו"ל או פשוט לא זמינים — העסק ממשיך לעבוד ואף לקוח לא הולך לאיבוד.',
        bullets: ['הלקוח מתקשר', 'ה-AI עונה ורושם את פרטי הפנייה', 'אתם מקבלים את כל המידע בצורה ברורה ופשוטה'],
      },
      plans: {
        heading: 'החבילות',
        body: 'מתחילים בקטן ועולים חבילה כשהעסק גדל.',
      },
      closing: {
        eyebrow: 'מערכת אחת. פחות התעסקות. יותר עסקאות!',
        heading: 'Worki',
        ctaLabel: 'התחילו עכשיו',
      },
    },
  },
  /**
   * LEGAL-001 — מדיניות הפרטיות ותנאי השימוש.
   *
   * שני המסמכים חיים כאן ולא בקובץ Markdown נפרד מפני שהם חייבים להתחלף בשפה
   * כמו כל טקסט אחר במוצר, ומפני שדף שהחנויות ומנגנון האימות של Google מושכים
   * אליו קישור לא יכול להיות תלוי בפריסה של קובץ סטטי.
   *
   * כל טענה כאן נבדקה מול הקוד: החתכים ב„כמה זמן” הם המספרים של
   * apps/api/src/services/retention.ts, ורשימת הצדדים השלישיים היא מה
   * ש-apps/api/src/env.ts באמת מפעיל. מי שמשנה אחד מהם משנה גם את הטקסט הזה.
   */
  legal: {
    updated: 'עודכן לאחרונה: 5 בנובמבר 2026',
    contact: 'darom.nadlan@gmail.com',
    back: 'חזרה',
    deleteAccount: {
      title: 'מחיקת חשבון Worki',
      intro:
        'אפשר לבקש מחיקת חשבון מתוך Worki או בדוא״ל. הדף הזה מסביר את התהליך ואת הרשומות שעשויות להישאר.',
      sections: [
        {
          heading: 'מתוך האפליקציה',
          body: [
            'נכנסים לאזור האישי, גוללים ל"מחיקת חשבון" ומקלידים את כתובת האימייל לאישור. אי אפשר לבטל את המחיקה. הסרת קבצים עשויה להימשך ברקע ולדרוש ניסיונות חוזרים במקרה של תקלה באחסון.',
            'Worki הוא אותו חשבון בדפדפן, באנדרואיד ובחלונות. מחיקה באחד מוחקת בכולם, כי מאחורי שלושתם עומד חשבון אחד.',
          ],
        },
        {
          heading: 'אם אי אפשר להיכנס לחשבון',
          body: [
            'שולחים בקשת מחיקה אל darom.nadlan@gmail.com. לפני ביצוע נצטרך לאמת שהבקשה היא של בעל החשבון. אם אין גישה לכתובת הרשומה, ציינו זאת כדי שנבחן דרך אחרת לאימות הזהות.',
          ],
        },
        {
          heading: 'מה נמחק',
          body: [
            'אם אתם האדם האחרון בעסק, העסק נמחק וכל מה שתויק תחתיו נמחק איתו: הלקוחות, הפניות, ההצעות והשורות שבהן, החשבוניות והתיקיות שמחזיקות אותן, תיק העבודות והמיני-סייט על התמונות והביקורות שבו, תיבות דואר מחוברות וההרשאה אליהן, מסמכים וחתימות שמורים, רישומי שיחות, תזכורות, הערות, התראות, הזמנות לצוות ורשומת המנוי. הקבצים המשויכים מיועדים להסרה; ההסרה עשויה להסתיים לאחר סגירת החשבון.',
            'אם יש עוד אנשים באותו עסק, נמחק רק המשתמש שלכם. העסק והעבודה שבו נשארים אצל מי שנשאר — עזיבת מקום עבודה לא אמורה למחוק את ההצעות של עמיתים.',
          ],
        },
        {
          heading: 'מה נשמר, ולמה',
          body: [
            'יומן הפעילות בנוי במערכת הנוכחית להוספת רשומות בלבד. רשומות, לרבות שם מבצע הפעולה, עשויות להישאר לאחר מחיקת חשבון לצורך תיעוד פעולות ואירועי אבטחה. דרישות שימור ובקשות הנוגעות לרשומות אלו דורשות בדיקה פרטנית. אין הבטחה להסרה מיידית של כל רשומה או גיבוי.',
            'מיילים שכבר נשלחו — הצעה ללקוח, קוד כניסה — נמצאים בתיבה של הנמען ומחוץ להישג ידנו. מחיקת החשבון לא מחזירה אותם.',
          ],
        },
      ],
    },
    privacy: {
      title: 'מדיניות פרטיות',
      intro:
        'Worki היא מערכת לניהול עסק קטן: פניות, הצעות מחיר, תיק עבודות, חשבוניות ושיחות. המסמך הזה מסביר איזה מידע נאסף, למה, למי הוא מועבר וכמה זמן הוא נשמר.',
      sections: [
        {
          "heading": "מידע נדרש וחיבורים אופציונליים",
          "body": [
            "פרטי חשבון וקשר נחוצים ליצירת חשבון ולשימוש בו. אתם בוחרים איזה תוכן עסקי ופרטי לקוחות להזין; היעדר מידע עשוי למנוע את הפעולה הקשורה אליו. חיבור Gmail, אנשי קשר, התראות, קול ו־AI הם אופציונליים. סירוב מונע את השימוש בתכונה המתאימה ואינו מעניק גישה למידע אחר.",
            "בוחר אנשי הקשר פועל במכשיר שלכם. רק פרטים שבחרתם ושלחתם בטופס Worki מועברים לשרת; ספר אנשי הקשר המלא אינו מועלה. בקשות קול ו־AI עשויות להעביר קול, טקסט והקשר הנחוץ לפעולה המבוקשת לשירות מרוחק. אין לכלול מידע שאינכם מורשים למסור.",
            "שילוב Google Calendar כבוי כעת בייצור. אם יופעל בהמשך, חיבורו יחייב את ההרשאה המתאימה. עוגיות התחברות נדרשות והעדפות מקומיות משמשות לכניסה ולממשק."
          ]
        },
        {
          "heading": "זהות השירות ויצירת קשר",
          "body": [
            "Worki הוא שם המוצר. אין בשם זה הצגה של חברה או עסק רשום בשם Worki או worki-top. הפעילות טרם נרשמה; זיהוי מלא של המפעיל וכתובת עסק טרם פורסמו. לפניות שירות ופרטיות אפשר לפנות אל darom.nadlan@gmail.com."
          ]
        },
        {
          heading: 'שני סוגי מידע, שתי אחריויות',
          body: [
            'המידע עליכם — בעל החשבון והמשתמשים בעסק — נאסף על ידי Worki לצורך הפעלת השירות, ואנחנו האחראים עליו.',
            'אתם מזינים פרטי לקוחות כגון שמות, טלפונים, כתובות והצעות מחיר. Worki מעבדת אותם כדי לספק את הפעולות שביקשתם, לרבות משלוח מסמכים ותיעוד אישורים. אתם אחראים להרשאה למסירתם ולפנייה לאנשים שאליהם הם נוגעים. Worki מעבדת גם רישומי פעילות ואבטחה לצורך הפעלת השירות והגנתו.',
          ],
        },
        {
          heading: 'מה נאסף עליכם',
          body: [
            'בהרשמה: שם, כתובת אימייל, שם העסק, תחום עיסוק, ומספר ח.פ/ע.מ אם הזנתם אותו. הכניסה היא בקוד חד־פעמי לאימייל או דרך חשבון Google — אין סיסמה, ולכן אין סיסמה לאבד.',
            'פעולות במערכת נרשמות ביומן המאפשר הוספת רשומות בלבד. הרשומות עשויות לכלול את שמכם ולהישאר לאחר מחיקת חשבון; ראו את סעיף השימור.',
          ],
        },
        {
          heading: 'מעקב אחרי הצעות מחיר ואחרי המיני־סייט',
          body: [
            'כשלקוח פותח הצעת מחיר ששלחתם, נרשמים מועד הפתיחה, כמה שניות ההצעה הייתה פתוחה, סוג הדפדפן, וטביעה חד־כיוונית של כתובת ה־IP. ברשומת הצפייה בהצעה נשמרת טביעה במקום כתובת ה־IP המקורית.',
            'במיני־סייט נשמרת טביעה יומית של המבקר, ותפקידה היחיד למנוע ספירה כפולה של אותו מבקר באותו יום.',
            'כשלקוח מאשר הצעה או חותם על מסמך, הטביעה והדפדפן נשמרים כראיה לאישור עצמו — לא כטלמטריה — ומתיישנים יחד עם המסמך.',
          ],
        },
        {
          heading: 'תיבות דוא״ל וחשבוניות',
          body: [
            'אם חיברתם תיבת Gmail או Microsoft, Worki סורקת אותה כדי לאתר חשבוניות. כדי לא להוריד את הדואר מחדש בכל סריקה, Worki שומרת עותק של ההודעות שהסריקה בודקת: שולח, נושא, תאריך, גוף ההודעה וקובצי ה־PDF המצורפים. מכל חשבונית שנמצאה נשמרים גם מסמך החשבונית ומה שחולץ ממנו: ספק, מספר, סכום, מטבע ותאריך. העותק נשמר רק עבור ארבע השנים האחרונות שהסריקה מכסה.',
            'Gmail מחובר בהרשאת קריאה בלבד לצורך איתור והצגת חשבוניות. שולח, נושא, תאריכים, גוף הודעות וקובצי PDF שנסרקו עשויים להישמר במטמון בתשתית שלנו. המידע מ־Gmail אינו נמכר, אינו משמש לפרסום ואינו משמש לאימון מודלי AI. השימוש במידע Google API כפוף ל־Google API Services User Data Policy, לרבות דרישות Limited Use.',
            'זיהוי החשבונית נעשה על השרת שלנו — חילוץ טקסט מ־PDF וזיהוי תווים בתמונה. שום תוכן דואר לא נשלח לספק בינה מלאכותית חיצוני.',
            'אפשר לנתק תיבה מתוך מסך החשבוניות בכל רגע, וגם לבטל את ההרשאה ישירות בעמוד ההרשאות של חשבון Google או Microsoft. ניתוק מפסיק כל סריקה עתידית ומוחק את אסימוני הגישה השמורים, את העותק של ההודעות ואת החשבוניות שנסרקו מהתיבה.',
          ],
        },
        {
          heading: 'שיחות ומספרים וירטואליים',
          body: [
            'למספר וירטואלי שהוקצה לעסק נשמרים פרטי השיחה: מספר מתקשר, מספר יעד, כיוון, משך, מועד ותוצאה. השיחה עצמה עוברת אצל ספק הטלפוניה; Worki לא מקליטה שיחות ולא שומרת תמלול.',
            'הגדרות סוכן ה־AI — שם, קול והשאלות שהוא אמור לשאול — הן טקסט שאתם כותבים ונשמר אצלנו כחלק מהגדרות העסק.',
          ],
        },
        {
          heading: 'תשלומים',
          body: [
            'התשלום מתבצע בעמוד מאובטח של חברת הסליקה. פרטי כרטיס אשראי לא עוברים דרך Worki ולא נשמרים אצלנו. מה שנשמר הוא מצב המנוי, החבילה, ורישום ההודעות שחברת הסליקה שלחה לנו.',
          ],
        },
        {
          heading: 'למי המידע מועבר',
          body: [
            'Google — כניסה לחשבון, וקריאת חשבוניות מ־Gmail כשחיברתם תיבה.',
            'Microsoft — קריאת חשבוניות מתיבת Outlook כשחיברתם אחת.',
            'ספק הטלפוניה — הודעות WhatsApp, מספרים וירטואליים ושיחות.',
            'חברת סליקה — כאשר תכונת תשלום מופעלת. חיוב מנויי Worki אוטומטי כבוי כעת.',
            'שרת הדואר היוצא — משלוח קודי כניסה, הצעות מחיר ותזכורות.',
            'Oracle Cloud מארחת את היישום ומסד הנתונים הראשיים בירושלים (il-jerusalem-1). תכונות קול ו־AI אופציונליות עשויות להשתמש בשירות Modal מרוחק שמיקום העיבוד שלו טרם אומת. Google Firebase Cloud Messaging מקבלת אסימוני מכשיר והודעות כלליות לצורך התראות דחיפה. לכן מידע עשוי להיות מעובד מחוץ לישראל; מיקום השרת הראשי אינו מתאר כל ספק או עותק. מידע עשוי להימסר גם עקב חובה בדין או צו שיפוטי.',
          ],
        },
        {
          heading: 'אבטחה',
          body: [
            'החיבור לשירות הציבורי משתמש ב־HTTPS. שדות סודיים של תיבות דואר מוצפנים ברמת השדה. Oracle מתעדת הצפנה במנוחה של נפחי Block ו־Boot. טרם הושלם אימות של כל גיבוי, מיפוי נפח או עותק, ולכן אין כאן טענה שכל עותק שמור נבדק בנפרד.',
            'מדדי הצפייה בהצעות ובמיני־סייט משתמשים בטביעות עם מפתח לצמצום זיהוי ישיר. ראיות חתימה עשויות לכלול טביעת חיבור ופרטי דפדפן.',
            'החיבור למערכת מוצפן, וההתחברות פגה מעצמה. אפשר לנתק את כל המכשירים המחוברים מהאזור האישי.',
          ],
        },
        {
          "heading": "כמה זמן נשמר המידע",
          "body": [
            "רשומות עסקיות נשמרות בדרך כלל כל עוד החשבון פעיל. לחלק מהקודים הזמניים, מזהי הצפייה, ההתראות והמטמונים יש ניקוי אוטומטי. מועדי ניקוי תפעוליים אינם הכרעה משפטית לגבי תקופת השימור הנדרשת לכל סוג מידע.",
            "יומן הפעולות המאפשר הוספה בלבד עשוי להישאר לאחר מחיקת חשבון. רשומות עסק משותף נשארות כאשר חברי צוות אחרים עדיין משתמשים בו. הסרת קבצים עשויה לדרוש ניסיונות חוזרים ברקע, ועותקים שכבר נשלחו לנמענים אינם ניתנים להחזרה. מיקומי גיבויים, מועדי מחיקתם וחובות השימור טרם אומתו במלואם. לבקשה בנוגע לרשומה מסוימת אפשר לפנות אלינו."
          ]
        },
        {
          heading: 'הזכויות שלכם',
          body: [
            'לפי חוק הגנת הפרטיות, התשמ״א־1981, אתם רשאים לעיין במידע שנשמר עליכם, לבקש לתקן מידע שגוי, ולבקש למחוק אותו. רוב המידע נגיש לכם ישירות במערכת וניתן לעריכה ולמחיקה משם.',
            'למחיקת החשבון כולו, או לכל בקשה אחרת, פנו אלינו בכתובת שבתחתית העמוד. נענה תוך זמן סביר.',
          ],
        },
        {
          heading: 'קטינים',
          body: ['השירות מיועד לבעלי עסקים, ולא נועד לשימוש מי שטרם מלאו לו 18.'],
        },
        {
          heading: 'שינויים במדיניות',
          body: [
            'אם נשנה את המדיניות נעדכן את התאריך בראש העמוד, ואם השינוי מהותי נודיע עליו במערכת לפני שהוא נכנס לתוקף.',
          ],
        },
      ],
    },
    terms: {
      title: 'תנאי שימוש',
      intro:
        'התנאים האלה חלים על השימוש ב־Worki. פתיחת חשבון או שימוש במערכת מהווים הסכמה להם.',
      sections: [
        {
          "heading": "חתימות אלקטרוניות ומסמכים",
          "body": [
            "Worki מתעדת חתימה אלקטרונית מצוירת וראיות נלוות כגון שם, מועד, טביעת חיבור ודפדפן. אין זו תעודה של גורם מאשר או טענה לחתימה אלקטרונית מאושרת. ההתאמה והמשקל הראייתי תלויים במסמך ובנסיבות; שימושים מסוימים מחייבים דרך חתימה אחרת.",
            "ייבוא חשבוניות, OCR ודוחות הם כלי ארגון. כשלעצמם הם אינם מקנים היתר לביעור מקור, לניכוי מס או לשימוש ב־Worki כמערכת מאושרת לניהול ספרים. יש לבדוק את הדרישות החלות על הפעילות שלכם לפני הסתמכות עליהם."
          ]
        },
        {
          "heading": "זהות השירות ויצירת קשר",
          "body": [
            "Worki הוא שם המוצר. אין בשם זה הצגה של חברה או עסק רשום בשם Worki או worki-top. הפעילות טרם נרשמה; זיהוי מלא של המפעיל וכתובת עסק טרם פורסמו. לפניות שירות ופרטיות אפשר לפנות אל darom.nadlan@gmail.com."
          ]
        },
        {
          heading: 'השירות',
          body: [
            'Worki מספקת כלים לניהול פניות, הצעות מחיר, תיק עבודות, חשבוניות, מסמכים לחתימה ושיחות נכנסות. היקף היכולות תלוי בחבילה שבחרתם.',
          ],
        },
        {
          heading: 'החשבון שלכם',
          body: [
            'החשבון אישי לעסק, ואתם אחראים למה שנעשה בו.',
            'הכניסה היא בקוד לאימייל או דרך Google. שמירה על הגישה לתיבת הדואר שלכם היא באחריותכם, מפני שהיא המפתח לחשבון.',
          ],
        },
        {
          heading: 'התוכן שלכם והלקוחות שלכם',
          body: [
            'התוכן שאתם מעלים — מחירים, תמונות, פרטי לקוחות — נשאר שלכם. אנחנו מחזיקים אותו כדי לספק את השירות ולא עושים בו שימוש אחר.',
            'אתם אחראים לכך שיש לכם רשות להזין את פרטי הלקוחות שלכם ולשלוח אליהם הודעות, ולעמידה בדין החל על הדיוור שאתם שולחים.',
          ],
        },
        {
          heading: 'שימוש אסור',
          body: [
            'אין להשתמש במערכת לדיוור זבל, להתחזות, לפרסום תוכן פוגעני או בלתי חוקי, לניסיון לחדור לחשבון של אחר, או להעמסה מכוונת על השירות.',
            'הפרה של הסעיף הזה מתירה לנו להשעות את החשבון, ובמקרה חמור לסגור אותו.',
          ],
        },
        {
          heading: 'התנסות, חבילות ותשלום',
          body: [
            'חיוב מנויי Worki אוטומטי כבוי כעת. הצגת מסלולים כשלעצמה אינה מפעילה חיוב. לפני הפעלת מנויים בתשלום יש להציג לאישור את המחיר הכולל לתשלום, הטיפול במס החל, תנאי חידוש וביטול, גישה והחזרים.',
            'לסגירת חשבון או לבירור תשלום אפשר לפנות אל darom.nadlan@gmail.com. תנאים אלו אינם מבטיחים גישה עד סוף תקופה ואינם גורעים מזכויות שלא ניתן להתנות עליהן לפי הדין החל.',
          ],
        },
        {
          heading: 'זמינות',
          body: [
            'אנחנו משתדלים שהשירות יהיה זמין ברציפות, אך אין התחייבות לזמינות מלאה. אנחנו עשויים לבצע עבודות תחזוקה, ולהעדיף שעות שבהן השימוש נמוך.',
          ],
        },
        {
          heading: 'קניין רוחני',
          body: [
            'התוכנה, השם, הלוגו והעיצוב הם שלנו. אין להעתיק אותם, למכור אותם או לגזור מהם מוצר מתחרה.',
          ],
        },
        {
          heading: 'אחריות',
          body: [
            'השירות ניתן כמות שהוא. איננו אחראים לנזק עקיף, לאובדן רווח או לאובדן נתונים שנגרם משימוש בשירות או מהפסקתו.',
            'בכל מקרה, אחריותנו הכוללת לא תעלה על הסכום ששילמתם בשנים־עשר החודשים שקדמו לאירוע.',
          ],
        },
        {
          heading: 'סיום',
          body: [
            'אפשר לסגור את החשבון בכל עת. אנחנו רשאים לסגור חשבון בהפרה של התנאים או באי־תשלום, לאחר הודעה.',
            'מחיקת חשבון מתבצעת כמפורט בדף מחיקת החשבון הציבורי. רשומות עסק משותף עשויות להישאר למשתמשים אחרים, יומן הפעולות עשוי להישאר לאחר הסגירה והסרת קבצים עשויה לדרוש ניסיונות חוזרים ברקע. עותקים אצל נמענים אינם בשליטתנו.',
          ],
        },
        {
          heading: 'דין וסמכות שיפוט',
          body: ['על התנאים חל הדין הישראלי, בכפוף להגנות ולהוראות סמכות שיפוט שלא ניתן להתנות עליהן.'],
        },
      ],
    },
    accessibility: {
      "title": "הצהרת נגישות",
      "intro": "הצהרה זו מתארת התאמות קיימות, מגבלות ידועות ודרך לבקשת עזרה. היא אינה אישור עמידה בתקן או הצהרה על פטור.",
      "sections": [
        {
          "heading": "התאמות שקיימות כיום",
          "body": [
            "הממשק כולל פקדים עם תוויות, תמיכה במקלדת ברכיבים רבים, קישור דילוג ליישום ועיצוב המתחשב בהעדפה להפחתת תנועה. אפשר להשתמש בעברית ובאנגלית. הכיסוי משתנה בין מסכים, והתאמות אלו לבדן אינן מוכיחות עמידה בתקן נגישות."
          ]
        },
        {
          "heading": "מגבלות והיקף הבדיקה",
          "body": [
            "טרם הושלמה בדיקה מקצועית מלאה של ניווט במקלדת, קוראי מסך, ניגודיות וכל תהליכי השימוש. משטחי חתימה, מסמכים שהועלו, קובצי PDF שמופקים ויישומי Android ו־Windows דורשים בדיקה נוספת. אין כרגע בסיס להצהיר על עמידה בת״י 5568 ברמת AA או על פטור חוקי."
          ]
        },
        {
          "heading": "בקשת עזרה או דיווח על חסם",
          "body": [
            "אפשר לפנות אל darom.nadlan@gmail.com ולציין את העמוד או התכונה, מה מנע את השלמת הפעולה, המכשיר והדפדפן, ואיזה פורמט או סיוע נדרשים. הימנעו ממשלוח מידע אישי או סודי שאינו נחוץ. אפשר לבקש הסבר בטקסט או דרך חלופית להשלמת פעולה; נבחן איתכם את הסיוע הזמין.",
            "דוא״ל זה הוא כתובת השירות הציבורית לפניות נגישות. לא מוצגים כאן רכז נגישות שמונה או זמן מענה קבוע."
          ]
        }
      ]
    },
  },
  pdf: {
    quote: 'הצעת מחיר',
    number: 'מספר',
    date: 'תאריך',
    to: 'לכבוד',
    description: 'תיאור',
    quantity: 'כמות',
    unitPrice: 'מחיר',
    lineTotal: 'סה"כ',
    included: 'כלול',
    subtotal: 'סכום ביניים',
    discount: 'הנחה',
    net: 'סכום לפני מע"מ',
    vat: 'מע"מ {{rate}}%',
    total: 'סה"כ לתשלום',
    notes: 'הערות',
    terms: 'תנאים והסכם',
    approvedStamp: 'אושר על ידי הלקוח בתאריך {{date}}',
    signedBy: 'נחתם על ידי',
    signedAt: 'מועד החתימה',
    generatedBy: 'הופק באמצעות Worki',
    certificateTitle: 'תיעוד ראיות לחתימה אלקטרונית',
    certificateIntro:
      'העמוד מתעד את החתימה המצוירת ואת פרטי ביצועה. הוא אינו תעודה של גורם מאשר ואינו מעיד על חתימה אלקטרונית מאושרת.',
    certificateDocument: 'המסמך',
    certificateReference: 'מזהה המסמך',
    certificateConnection: 'טביעת חיבור',
    certificateDrawing: 'החתימה כפי שנחתמה',
    /* SIG-003 — on a document several people sign, a line each. */
    certificatePending: 'טרם נחתם',
    /* 2.5 — worded as on the profile, where the owner typed the number in. */
    taxId: 'ח.פ. / ע.מ.',
  },
  /* Chrome around every screen: rail, app bar, bottom bar and the small
     controls the ported screens share (row menus, in-page search). */
  shell: {
    navigationToBottom: 'העברת הניווט לתחתית',
    navigationToSidebar: 'העברת הניווט לצד',
    // Not "פניות ושיחות" any more: the call log went back to being a screen of
    // its own, and a label that names a list the screen does not hold is a
    // promise the screen breaks. One label now, because with the "and calls"
    // gone the rail and the bottom bar want the same word.
    navLeads: 'פניות',
    navGallery: 'גלריה',
    navInvoicesEmail: 'חשבוניות מהדוא״ל',
    // The bottom bar's own wording. It was cut to one word so a slot could hold
    // it on one line, and "חשבוניות" next to a mail icon is the screen named
    // after the wrong half of itself — the invoices a business writes are a
    // different thing from the ones that arrive in its mailbox. The slot wraps
    // to two lines instead.
    navInvoicesShort: 'חשבוניות דוא״ל',
    navPersonalArea: 'אזור אישי',
    new: 'חדש',
    newAction: 'פעולה חדשה',
    sendHistory: 'היסטוריית שליחות',
    // The full name in the bottom bar too. "היסטוריה" on its own is a word the
    // screen shares with the activity log and the invoice archive; what this
    // slot opens is the history of what was sent.
    sendHistoryShort: 'היסטוריית שליחות',
    home: 'Worki — לוח בקרה',
    collapse: 'כיווץ התפריט',
    frontMenu: 'התפריט שלי',
    expand: 'הרחבת התפריט',
    viewAllNotifications: 'צפה בכל ההתראות והתזכורות',
    search: 'חיפוש',
    searchPlaceholder: 'חיפוש בעמוד…',
    closeSearch: 'סגירת החיפוש',
    view: 'צפה',
    resend: 'שלח שוב',
    resendCount: 'שלח שוב ({{count}})',
  },
  /* The accent-colour fan in the personal area. Colour names only. */
  theme: {
    title: 'צבע המערכת',
    subtitle: 'בחר צבע ראשי — הוא יחול על כל המסכים',
    color: {
      purple: 'סגול',
      indigo: 'אינדיגו',
      blue: 'כחול',
      cyan: 'תכלת',
      teal: 'טורקיז',
      green: 'ירוק',
      lime: 'ליים',
      gold: 'זהב',
      orange: 'כתום',
      red: 'אדום',
      pink: 'ורוד',
      slate: 'גרפיט',
      violet: 'סגול עז',
      lavender: 'לבנדר',
      fuchsia: 'פוקסיה',
      rose: 'רוז',
      coral: 'אלמוג',
      amber: 'ענבר',
      olive: 'זית',
      emerald: 'אמרלד',
      sky: 'שמיים',
      navy: 'כחול כהה',
      steel: 'פלדה',
      mocha: 'מוקה',
      plum: 'שזיף',
      black: 'שחור',
    },
  },
} as const;
